var Gs = Object.defineProperty;
var Ws = (e, t, o) => t in e ? Gs(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o;
var st = (e, t, o) => Ws(e, typeof t != "symbol" ? t + "" : t, o);
function pe(e, t) {
  const o = e.getAttributeNames(), s = Object.keys(t);
  for (const n of o)
    n !== "id" && !s.includes(n) && e.removeAttribute(n);
}
const Fe = "rb-energy-drink-rail";
async function uc(e, t) {
  await customElements.whenDefined(Fe);
  const o = document.getElementById(e);
  if (!o)
    throw new Error(`html element with id ${e} not found!`);
  Object.assign(o, t), pe(o, t);
}
async function fc(e, t) {
  await customElements.whenDefined(Fe), Object.assign(e, t), pe(e, t);
}
const Ys = [
  "custom-data-layer",
  "locale",
  "skip-cosmos-font-injection"
];
var Ee, w, Yo, se, Wt, Xo, Jo, Zo, At, ct, lt, Qo, ye = {}, Ko = [], Xs = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, Ce = Array.isArray;
function N(e, t) {
  for (var o in t) e[o] = t[o];
  return e;
}
function Tt(e) {
  e && e.parentNode && e.parentNode.removeChild(e);
}
function M(e, t, o) {
  var s, n, i, r = {};
  for (i in t) i == "key" ? s = t[i] : i == "ref" ? n = t[i] : r[i] = t[i];
  if (arguments.length > 2 && (r.children = arguments.length > 3 ? Ee.call(arguments, 2) : o), typeof e == "function" && e.defaultProps != null) for (i in e.defaultProps) r[i] === void 0 && (r[i] = e.defaultProps[i]);
  return xe(e, r, s, n, null);
}
function xe(e, t, o, s, n) {
  var i = { type: e, props: t, key: o, ref: s, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: n ?? ++Yo, __i: -1, __u: 0 };
  return n == null && w.vnode != null && w.vnode(i), i;
}
function H(e) {
  return e.children;
}
function Y(e, t) {
  this.props = e, this.context = t;
}
function de(e, t) {
  if (t == null) return e.__ ? de(e.__, e.__i + 1) : null;
  for (var o; t < e.__k.length; t++) if ((o = e.__k[t]) != null && o.__e != null) return o.__e;
  return typeof e.type == "function" ? de(e) : null;
}
function Vo(e) {
  var t, o;
  if ((e = e.__) != null && e.__c != null) {
    for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++) if ((o = e.__k[t]) != null && o.__e != null) {
      e.__e = e.__c.base = o.__e;
      break;
    }
    return Vo(e);
  }
}
function dt(e) {
  (!e.__d && (e.__d = !0) && se.push(e) && !Be.__r++ || Wt != w.debounceRendering) && ((Wt = w.debounceRendering) || Xo)(Be);
}
function Be() {
  for (var e, t, o, s, n, i, r, a = 1; se.length; ) se.length > a && se.sort(Jo), e = se.shift(), a = se.length, e.__d && (o = void 0, n = (s = (t = e).__v).__e, i = [], r = [], t.__P && ((o = N({}, s)).__v = s.__v + 1, w.vnode && w.vnode(o), Rt(t.__P, o, s, t.__n, t.__P.namespaceURI, 32 & s.__u ? [n] : null, i, n ?? de(s), !!(32 & s.__u), r), o.__v = s.__v, o.__.__k[o.__i] = o, os(i, o, r), o.__e != n && Vo(o)));
  Be.__r = 0;
}
function es(e, t, o, s, n, i, r, a, l, c, m) {
  var d, u, f, g, b, x, h = s && s.__k || Ko, y = t.length;
  for (l = Js(o, t, h, l, y), d = 0; d < y; d++) (f = o.__k[d]) != null && (u = f.__i == -1 ? ye : h[f.__i] || ye, f.__i = d, x = Rt(e, f, u, n, i, r, a, l, c, m), g = f.__e, f.ref && u.ref != f.ref && (u.ref && Lt(u.ref, null, f), m.push(f.ref, f.__c || g, f)), b == null && g != null && (b = g), 4 & f.__u || u.__k === f.__k ? l = ts(f, l, e) : typeof f.type == "function" && x !== void 0 ? l = x : g && (l = g.nextSibling), f.__u &= -7);
  return o.__e = b, l;
}
function Js(e, t, o, s, n) {
  var i, r, a, l, c, m = o.length, d = m, u = 0;
  for (e.__k = new Array(n), i = 0; i < n; i++) (r = t[i]) != null && typeof r != "boolean" && typeof r != "function" ? (l = i + u, (r = e.__k[i] = typeof r == "string" || typeof r == "number" || typeof r == "bigint" || r.constructor == String ? xe(null, r, null, null, null) : Ce(r) ? xe(H, { children: r }, null, null, null) : r.constructor == null && r.__b > 0 ? xe(r.type, r.props, r.key, r.ref ? r.ref : null, r.__v) : r).__ = e, r.__b = e.__b + 1, a = null, (c = r.__i = Zs(r, o, l, d)) != -1 && (d--, (a = o[c]) && (a.__u |= 2)), a == null || a.__v == null ? (c == -1 && (n > m ? u-- : n < m && u++), typeof r.type != "function" && (r.__u |= 4)) : c != l && (c == l - 1 ? u-- : c == l + 1 ? u++ : (c > l ? u-- : u++, r.__u |= 4))) : e.__k[i] = null;
  if (d) for (i = 0; i < m; i++) (a = o[i]) != null && !(2 & a.__u) && (a.__e == s && (s = de(a)), ns(a, a));
  return s;
}
function ts(e, t, o) {
  var s, n;
  if (typeof e.type == "function") {
    for (s = e.__k, n = 0; s && n < s.length; n++) s[n] && (s[n].__ = e, t = ts(s[n], t, o));
    return t;
  }
  e.__e != t && (t && e.type && !o.contains(t) && (t = de(e)), o.insertBefore(e.__e, t || null), t = e.__e);
  do
    t = t && t.nextSibling;
  while (t != null && t.nodeType == 8);
  return t;
}
function Ue(e, t) {
  return t = t || [], e == null || typeof e == "boolean" || (Ce(e) ? e.some(function(o) {
    Ue(o, t);
  }) : t.push(e)), t;
}
function Zs(e, t, o, s) {
  var n, i, r, a = e.key, l = e.type, c = t[o], m = c != null && (2 & c.__u) == 0;
  if (c === null && e.key == null || m && a == c.key && l == c.type) return o;
  if (s > (m ? 1 : 0)) {
    for (n = o - 1, i = o + 1; n >= 0 || i < t.length; ) if ((c = t[r = n >= 0 ? n-- : i++]) != null && !(2 & c.__u) && a == c.key && l == c.type) return r;
  }
  return -1;
}
function Yt(e, t, o) {
  t[0] == "-" ? e.setProperty(t, o ?? "") : e[t] = o == null ? "" : typeof o != "number" || Xs.test(t) ? o : o + "px";
}
function Le(e, t, o, s, n) {
  var i, r;
  e: if (t == "style") if (typeof o == "string") e.style.cssText = o;
  else {
    if (typeof s == "string" && (e.style.cssText = s = ""), s) for (t in s) o && t in o || Yt(e.style, t, "");
    if (o) for (t in o) s && o[t] == s[t] || Yt(e.style, t, o[t]);
  }
  else if (t[0] == "o" && t[1] == "n") i = t != (t = t.replace(Zo, "$1")), r = t.toLowerCase(), t = r in e || t == "onFocusOut" || t == "onFocusIn" ? r.slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + i] = o, o ? s ? o.u = s.u : (o.u = At, e.addEventListener(t, i ? lt : ct, i)) : e.removeEventListener(t, i ? lt : ct, i);
  else {
    if (n == "http://www.w3.org/2000/svg") t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if (t != "width" && t != "height" && t != "href" && t != "list" && t != "form" && t != "tabIndex" && t != "download" && t != "rowSpan" && t != "colSpan" && t != "role" && t != "popover" && t in e) try {
      e[t] = o ?? "";
      break e;
    } catch {
    }
    typeof o == "function" || (o == null || o === !1 && t[4] != "-" ? e.removeAttribute(t) : e.setAttribute(t, t == "popover" && o == 1 ? "" : o));
  }
}
function Xt(e) {
  return function(t) {
    if (this.l) {
      var o = this.l[t.type + e];
      if (t.t == null) t.t = At++;
      else if (t.t < o.u) return;
      return o(w.event ? w.event(t) : t);
    }
  };
}
function Rt(e, t, o, s, n, i, r, a, l, c) {
  var m, d, u, f, g, b, x, h, y, E, k, L, D, X, C, $, T, _ = t.type;
  if (t.constructor != null) return null;
  128 & o.__u && (l = !!(32 & o.__u), i = [a = t.__e = o.__e]), (m = w.__b) && m(t);
  e: if (typeof _ == "function") try {
    if (h = t.props, y = "prototype" in _ && _.prototype.render, E = (m = _.contextType) && s[m.__c], k = m ? E ? E.props.value : m.__ : s, o.__c ? x = (d = t.__c = o.__c).__ = d.__E : (y ? t.__c = d = new _(h, k) : (t.__c = d = new Y(h, k), d.constructor = _, d.render = Ks), E && E.sub(d), d.props = h, d.state || (d.state = {}), d.context = k, d.__n = s, u = d.__d = !0, d.__h = [], d._sb = []), y && d.__s == null && (d.__s = d.state), y && _.getDerivedStateFromProps != null && (d.__s == d.state && (d.__s = N({}, d.__s)), N(d.__s, _.getDerivedStateFromProps(h, d.__s))), f = d.props, g = d.state, d.__v = t, u) y && _.getDerivedStateFromProps == null && d.componentWillMount != null && d.componentWillMount(), y && d.componentDidMount != null && d.__h.push(d.componentDidMount);
    else {
      if (y && _.getDerivedStateFromProps == null && h !== f && d.componentWillReceiveProps != null && d.componentWillReceiveProps(h, k), !d.__e && d.shouldComponentUpdate != null && d.shouldComponentUpdate(h, d.__s, k) === !1 || t.__v == o.__v) {
        for (t.__v != o.__v && (d.props = h, d.state = d.__s, d.__d = !1), t.__e = o.__e, t.__k = o.__k, t.__k.some(function(z) {
          z && (z.__ = t);
        }), L = 0; L < d._sb.length; L++) d.__h.push(d._sb[L]);
        d._sb = [], d.__h.length && r.push(d);
        break e;
      }
      d.componentWillUpdate != null && d.componentWillUpdate(h, d.__s, k), y && d.componentDidUpdate != null && d.__h.push(function() {
        d.componentDidUpdate(f, g, b);
      });
    }
    if (d.context = k, d.props = h, d.__P = e, d.__e = !1, D = w.__r, X = 0, y) {
      for (d.state = d.__s, d.__d = !1, D && D(t), m = d.render(d.props, d.state, d.context), C = 0; C < d._sb.length; C++) d.__h.push(d._sb[C]);
      d._sb = [];
    } else do
      d.__d = !1, D && D(t), m = d.render(d.props, d.state, d.context), d.state = d.__s;
    while (d.__d && ++X < 25);
    d.state = d.__s, d.getChildContext != null && (s = N(N({}, s), d.getChildContext())), y && !u && d.getSnapshotBeforeUpdate != null && (b = d.getSnapshotBeforeUpdate(f, g)), $ = m, m != null && m.type === H && m.key == null && ($ = ss(m.props.children)), a = es(e, Ce($) ? $ : [$], t, o, s, n, i, r, a, l, c), d.base = t.__e, t.__u &= -161, d.__h.length && r.push(d), x && (d.__E = d.__ = null);
  } catch (z) {
    if (t.__v = null, l || i != null) if (z.then) {
      for (t.__u |= l ? 160 : 128; a && a.nodeType == 8 && a.nextSibling; ) a = a.nextSibling;
      i[i.indexOf(a)] = null, t.__e = a;
    } else {
      for (T = i.length; T--; ) Tt(i[T]);
      mt(t);
    }
    else t.__e = o.__e, t.__k = o.__k, z.then || mt(t);
    w.__e(z, t, o);
  }
  else i == null && t.__v == o.__v ? (t.__k = o.__k, t.__e = o.__e) : a = t.__e = Qs(o.__e, t, o, s, n, i, r, l, c);
  return (m = w.diffed) && m(t), 128 & t.__u ? void 0 : a;
}
function mt(e) {
  e && e.__c && (e.__c.__e = !0), e && e.__k && e.__k.forEach(mt);
}
function os(e, t, o) {
  for (var s = 0; s < o.length; s++) Lt(o[s], o[++s], o[++s]);
  w.__c && w.__c(t, e), e.some(function(n) {
    try {
      e = n.__h, n.__h = [], e.some(function(i) {
        i.call(n);
      });
    } catch (i) {
      w.__e(i, n.__v);
    }
  });
}
function ss(e) {
  return typeof e != "object" || e == null || e.__b && e.__b > 0 ? e : Ce(e) ? e.map(ss) : N({}, e);
}
function Qs(e, t, o, s, n, i, r, a, l) {
  var c, m, d, u, f, g, b, x = o.props, h = t.props, y = t.type;
  if (y == "svg" ? n = "http://www.w3.org/2000/svg" : y == "math" ? n = "http://www.w3.org/1998/Math/MathML" : n || (n = "http://www.w3.org/1999/xhtml"), i != null) {
    for (c = 0; c < i.length; c++) if ((f = i[c]) && "setAttribute" in f == !!y && (y ? f.localName == y : f.nodeType == 3)) {
      e = f, i[c] = null;
      break;
    }
  }
  if (e == null) {
    if (y == null) return document.createTextNode(h);
    e = document.createElementNS(n, y, h.is && h), a && (w.__m && w.__m(t, i), a = !1), i = null;
  }
  if (y == null) x === h || a && e.data == h || (e.data = h);
  else {
    if (i = i && Ee.call(e.childNodes), x = o.props || ye, !a && i != null) for (x = {}, c = 0; c < e.attributes.length; c++) x[(f = e.attributes[c]).name] = f.value;
    for (c in x) if (f = x[c], c != "children") {
      if (c == "dangerouslySetInnerHTML") d = f;
      else if (!(c in h)) {
        if (c == "value" && "defaultValue" in h || c == "checked" && "defaultChecked" in h) continue;
        Le(e, c, null, f, n);
      }
    }
    for (c in h) f = h[c], c == "children" ? u = f : c == "dangerouslySetInnerHTML" ? m = f : c == "value" ? g = f : c == "checked" ? b = f : a && typeof f != "function" || x[c] === f || Le(e, c, f, x[c], n);
    if (m) a || d && (m.__html == d.__html || m.__html == e.innerHTML) || (e.innerHTML = m.__html), t.__k = [];
    else if (d && (e.innerHTML = ""), es(t.type == "template" ? e.content : e, Ce(u) ? u : [u], t, o, s, y == "foreignObject" ? "http://www.w3.org/1999/xhtml" : n, i, r, i ? i[0] : o.__k && de(o, 0), a, l), i != null) for (c = i.length; c--; ) Tt(i[c]);
    a || (c = "value", y == "progress" && g == null ? e.removeAttribute("value") : g != null && (g !== e[c] || y == "progress" && !g || y == "option" && g != x[c]) && Le(e, c, g, x[c], n), c = "checked", b != null && b != e[c] && Le(e, c, b, x[c], n));
  }
  return e;
}
function Lt(e, t, o) {
  try {
    if (typeof e == "function") {
      var s = typeof e.__u == "function";
      s && e.__u(), s && t == null || (e.__u = e(t));
    } else e.current = t;
  } catch (n) {
    w.__e(n, o);
  }
}
function ns(e, t, o) {
  var s, n;
  if (w.unmount && w.unmount(e), (s = e.ref) && (s.current && s.current != e.__e || Lt(s, null, t)), (s = e.__c) != null) {
    if (s.componentWillUnmount) try {
      s.componentWillUnmount();
    } catch (i) {
      w.__e(i, t);
    }
    s.base = s.__P = null;
  }
  if (s = e.__k) for (n = 0; n < s.length; n++) s[n] && ns(s[n], t, o || typeof e.type != "function");
  o || Tt(e.__e), e.__c = e.__ = e.__e = void 0;
}
function Ks(e, t, o) {
  return this.constructor(e, o);
}
function Qe(e, t, o) {
  var s, n, i, r;
  t == document && (t = document.documentElement), w.__ && w.__(e, t), n = (s = typeof o == "function") ? null : o && o.__k || t.__k, i = [], r = [], Rt(t, e = (!s && o || t).__k = M(H, null, [e]), n || ye, ye, t.namespaceURI, !s && o ? [o] : n ? null : t.firstChild ? Ee.call(t.childNodes) : null, i, !s && o ? o : n ? n.__e : t.firstChild, s, r), os(i, e, r);
}
function is(e, t) {
  Qe(e, t, is);
}
function rs(e, t, o) {
  var s, n, i, r, a = N({}, e.props);
  for (i in e.type && e.type.defaultProps && (r = e.type.defaultProps), t) i == "key" ? s = t[i] : i == "ref" ? n = t[i] : a[i] = t[i] === void 0 && r != null ? r[i] : t[i];
  return arguments.length > 2 && (a.children = arguments.length > 3 ? Ee.call(arguments, 2) : o), xe(e.type, a, s || e.key, n || e.ref, null);
}
function Vs(e) {
  function t(o) {
    var s, n;
    return this.getChildContext || (s = /* @__PURE__ */ new Set(), (n = {})[t.__c] = this, this.getChildContext = function() {
      return n;
    }, this.componentWillUnmount = function() {
      s = null;
    }, this.shouldComponentUpdate = function(i) {
      this.props.value != i.value && s.forEach(function(r) {
        r.__e = !0, dt(r);
      });
    }, this.sub = function(i) {
      s.add(i);
      var r = i.componentWillUnmount;
      i.componentWillUnmount = function() {
        s && s.delete(i), r && r.call(i);
      };
    }), o.children;
  }
  return t.__c = "__cC" + Qo++, t.__ = e, t.Provider = t.__l = (t.Consumer = function(o, s) {
    return o.children(s);
  }).contextType = t, t;
}
Ee = Ko.slice, w = { __e: function(e, t, o, s) {
  for (var n, i, r; t = t.__; ) if ((n = t.__c) && !n.__) try {
    if ((i = n.constructor) && i.getDerivedStateFromError != null && (n.setState(i.getDerivedStateFromError(e)), r = n.__d), n.componentDidCatch != null && (n.componentDidCatch(e, s || {}), r = n.__d), r) return n.__E = n;
  } catch (a) {
    e = a;
  }
  throw e;
} }, Yo = 0, Y.prototype.setState = function(e, t) {
  var o;
  o = this.__s != null && this.__s != this.state ? this.__s : this.__s = N({}, this.state), typeof e == "function" && (e = e(N({}, o), this.props)), e && N(o, e), e != null && this.__v && (t && this._sb.push(t), dt(this));
}, Y.prototype.forceUpdate = function(e) {
  this.__v && (this.__e = !0, e && this.__h.push(e), dt(this));
}, Y.prototype.render = H, se = [], Xo = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Jo = function(e, t) {
  return e.__v.__b - t.__v.__b;
}, Be.__r = 0, Zo = /(PointerCapture)$|Capture$/i, At = 0, ct = Xt(!1), lt = Xt(!0), Qo = 0;
var en = 0;
function p(e, t, o, s, n, i) {
  t || (t = {});
  var r, a, l = t;
  if ("ref" in l) for (a in l = {}, t) a == "ref" ? r = t[a] : l[a] = t[a];
  var c = { type: e, props: l, key: o, ref: r, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: --en, __i: -1, __u: 0, __source: n, __self: i };
  if (typeof e == "function" && (r = e.defaultProps)) for (a in r) l[a] === void 0 && (l[a] = r[a]);
  return w.vnode && w.vnode(c), c;
}
var me, R, nt, Jt, we = 0, as = [], I = w, Zt = I.__b, Qt = I.__r, Kt = I.diffed, Vt = I.__c, eo = I.unmount, to = I.__;
function Ke(e, t) {
  I.__h && I.__h(R, e, we || t), we = 0;
  var o = R.__H || (R.__H = { __: [], __h: [] });
  return e >= o.__.length && o.__.push({}), o.__[e];
}
function Se(e) {
  return we = 1, tn(ls, e);
}
function tn(e, t, o) {
  var s = Ke(me++, 2);
  if (s.t = e, !s.__c && (s.__ = [o ? o(t) : ls(void 0, t), function(a) {
    var l = s.__N ? s.__N[0] : s.__[0], c = s.t(l, a);
    l !== c && (s.__N = [c, s.__[1]], s.__c.setState({}));
  }], s.__c = R, !R.__f)) {
    var n = function(a, l, c) {
      if (!s.__c.__H) return !0;
      var m = s.__c.__H.__.filter(function(u) {
        return !!u.__c;
      });
      if (m.every(function(u) {
        return !u.__N;
      })) return !i || i.call(this, a, l, c);
      var d = s.__c.props !== a;
      return m.forEach(function(u) {
        if (u.__N) {
          var f = u.__[0];
          u.__ = u.__N, u.__N = void 0, f !== u.__[0] && (d = !0);
        }
      }), i && i.call(this, a, l, c) || d;
    };
    R.__f = !0;
    var i = R.shouldComponentUpdate, r = R.componentWillUpdate;
    R.componentWillUpdate = function(a, l, c) {
      if (this.__e) {
        var m = i;
        i = void 0, n(a, l, c), i = m;
      }
      r && r.call(this, a, l, c);
    }, R.shouldComponentUpdate = n;
  }
  return s.__N || s.__;
}
function U(e, t) {
  var o = Ke(me++, 3);
  !I.__s && cs(o.__H, t) && (o.__ = e, o.u = t, R.__H.__h.push(o));
}
function ut(e) {
  return we = 5, be(function() {
    return { current: e };
  }, []);
}
function be(e, t) {
  var o = Ke(me++, 7);
  return cs(o.__H, t) && (o.__ = e(), o.__H = t, o.__h = e), o.__;
}
function _e(e, t) {
  return we = 8, be(function() {
    return e;
  }, t);
}
function on(e) {
  var t = R.context[e.__c], o = Ke(me++, 9);
  return o.c = e, t ? (o.__ == null && (o.__ = !0, t.sub(R)), t.props.value) : e.__;
}
function sn() {
  for (var e; e = as.shift(); ) if (e.__P && e.__H) try {
    e.__H.__h.forEach(De), e.__H.__h.forEach(ft), e.__H.__h = [];
  } catch (t) {
    e.__H.__h = [], I.__e(t, e.__v);
  }
}
I.__b = function(e) {
  R = null, Zt && Zt(e);
}, I.__ = function(e, t) {
  e && t.__k && t.__k.__m && (e.__m = t.__k.__m), to && to(e, t);
}, I.__r = function(e) {
  Qt && Qt(e), me = 0;
  var t = (R = e.__c).__H;
  t && (nt === R ? (t.__h = [], R.__h = [], t.__.forEach(function(o) {
    o.__N && (o.__ = o.__N), o.u = o.__N = void 0;
  })) : (t.__h.forEach(De), t.__h.forEach(ft), t.__h = [], me = 0)), nt = R;
}, I.diffed = function(e) {
  Kt && Kt(e);
  var t = e.__c;
  t && t.__H && (t.__H.__h.length && (as.push(t) !== 1 && Jt === I.requestAnimationFrame || ((Jt = I.requestAnimationFrame) || nn)(sn)), t.__H.__.forEach(function(o) {
    o.u && (o.__H = o.u), o.u = void 0;
  })), nt = R = null;
}, I.__c = function(e, t) {
  t.some(function(o) {
    try {
      o.__h.forEach(De), o.__h = o.__h.filter(function(s) {
        return !s.__ || ft(s);
      });
    } catch (s) {
      t.some(function(n) {
        n.__h && (n.__h = []);
      }), t = [], I.__e(s, o.__v);
    }
  }), Vt && Vt(e, t);
}, I.unmount = function(e) {
  eo && eo(e);
  var t, o = e.__c;
  o && o.__H && (o.__H.__.forEach(function(s) {
    try {
      De(s);
    } catch (n) {
      t = n;
    }
  }), o.__H = void 0, t && I.__e(t, o.__v));
};
var oo = typeof requestAnimationFrame == "function";
function nn(e) {
  var t, o = function() {
    clearTimeout(s), oo && cancelAnimationFrame(t), setTimeout(e);
  }, s = setTimeout(o, 35);
  oo && (t = requestAnimationFrame(o));
}
function De(e) {
  var t = R, o = e.__c;
  typeof o == "function" && (e.__c = void 0, o()), R = t;
}
function ft(e) {
  var t = R;
  e.__c = e.__(), R = t;
}
function cs(e, t) {
  return !e || e.length !== t.length || t.some(function(o, s) {
    return o !== e[s];
  });
}
function ls(e, t) {
  return typeof t == "function" ? t(e) : t;
}
const It = '@font-face{font-family:Bull Text;font-style:normal;font-weight:400;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Regular.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Regular.woff) format("woff")}@font-face{font-family:Bull Text;font-style:normal;font-weight:500;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Medium.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Medium.woff) format("woff")}@font-face{font-family:Bull Text;font-style:normal;font-weight:700;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Bold.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Bold.woff) format("woff")}@font-face{font-family:Bull;font-style:normal;font-weight:700;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Bold.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Bold.woff) format("woff")}@font-face{font-family:Bull;font-style:normal;font-weight:800;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Heavy1.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Heavy1.woff) format("woff")}@font-face{font-family:Bull VF;font-style:normal;font-weight:300 800;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullVAR.woff2) format("woff2-variations"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullVAR.woff2) format("woff2")}';
function Ne(e) {
  return e.replace(/\b(red) (bull)\b/gi, "$1 $2");
}
const ds = "rb-smart-components-cosmos-font-injection";
function Ot(e) {
  if (!rn()) {
    const t = document.createElement("style");
    t.id = ds, t.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(t);
  }
}
function rn() {
  return document.getElementById(ds) !== null;
}
function Me(e) {
  return typeof e == "boolean" ? e : typeof e == "string" ? e === "true" : !1;
}
const an = (e) => e.toLowerCase().split("-").map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join(""), cn = (e) => e.indexOf("on") === 0 && e[2] === e[2].toUpperCase(), ln = (e) => `on${e[2].toLowerCase()}${e.substring(3)}`, dn = (e) => e.replace(/([A-Z]+)([A-Z][a-z])/g, "$1-$2").replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), mn = {
  acceptCharset: "accept-charset",
  accessKey: "accesskey",
  allowFullScreen: "allowfullscreen",
  autoCapitalize: "autocapitalize",
  autoComplete: "autocomplete",
  autoCorrect: "autocorrect",
  autoFocus: "autofocus",
  autoPlay: "autoplay",
  autoSave: "autosave",
  cellPadding: "cellpadding",
  cellSpacing: "cellspacing",
  charSet: "charset",
  className: "class",
  classID: "classid",
  colSpan: "colspan",
  contentEditable: "contenteditable",
  contextMenu: "contextmenu",
  controlsList: "controlslist",
  crossOrigin: "crossorigin",
  dateTime: "datetime",
  defaultChecked: "defaultchecked",
  defaultValue: "defaultvalue",
  disablePictureInPicture: "disablepictureinpicture",
  disableRemotePlayback: "disableremoteplayback",
  encType: "enctype",
  enterKeyHint: "enterkeyhint",
  fetchPriority: "fetchpriority",
  htmlFor: "for",
  formMethod: "formmethod",
  formAction: "formaction",
  formEncType: "formenctype",
  formNoValidate: "formnovalidate",
  formTarget: "formtarget",
  frameBorder: "frameborder",
  hrefLang: "hreflang",
  httpEquiv: "http-equiv",
  imageSizes: "imagesizes",
  imageSrcSet: "imagesrcset",
  inputMode: "inputmode",
  itemID: "itemid",
  itemProp: "itemprop",
  itemRef: "itemref",
  itemScope: "itemscope",
  itemType: "itemtype",
  keyParams: "keyparams",
  keyType: "keytype",
  marginWidth: "marginwidth",
  marginHeight: "marginheight",
  maxLength: "maxlength",
  mediaGroup: "mediagroup",
  noModule: "nomodule",
  noValidate: "novalidate",
  playsInline: "playsinline",
  radioGroup: "radiogroup",
  readOnly: "readonly",
  referrerPolicy: "referrerpolicy",
  rowSpan: "rowspan",
  spellCheck: "spellcheck",
  srcDoc: "srcdoc",
  srcLang: "srclang",
  srcSet: "srcset",
  tabIndex: "tabindex",
  useMap: "usemap",
  accentHeight: "accent-height",
  alignmentBaseline: "alignment-baseline",
  arabicForm: "arabic-form",
  attributeName: "attributename",
  attributeType: "attributetype",
  autoReverse: "autoreverse",
  baseFrequency: "basefrequency",
  baselineShift: "baseline-shift",
  baseProfile: "baseprofile",
  calcMode: "calcmode",
  capHeight: "cap-height",
  clipPath: "clip-path",
  clipPathUnits: "clippathunits",
  clipRule: "clip-rule",
  colorInterpolation: "color-interpolation",
  colorInterpolationFilters: "color-interpolation-filters",
  colorProfile: "color-profile",
  colorRendering: "color-rendering",
  contentScriptType: "contentscripttype",
  contentStyleType: "contentstyletype",
  diffuseConstant: "diffuseconstant",
  dominantBaseline: "dominant-baseline",
  enableBackground: "enable-background",
  externalResourcesRequired: "externalresourcesrequired",
  fillOpacity: "fill-opacity",
  fillRule: "fill-rule",
  filterRes: "filterres",
  filterUnits: "filterunits",
  floodOpacity: "flood-opacity",
  floodColor: "flood-color",
  fontFamily: "font-family",
  fontSize: "font-size",
  fontSizeAdjust: "font-size-adjust",
  fontStretch: "font-stretch",
  fontStyle: "font-style",
  fontVariant: "font-variant",
  fontWeight: "font-weight",
  glyphName: "glyph-name",
  glyphOrientationHorizontal: "glyph-orientation-horizontal",
  glyphOrientationVertical: "glyph-orientation-vertical",
  gradientTransform: "gradienttransform",
  gradientUnits: "gradientunits",
  horizAdvX: "horiz-adv-x",
  horizOriginX: "horiz-origin-x",
  imageRendering: "image-rendering",
  kernelMatrix: "kernelmatrix",
  kernelUnitLength: "kernelunitlength",
  keyPoints: "keypoints",
  keySplines: "keysplines",
  keyTimes: "keytimes",
  lengthAdjust: "lengthadjust",
  letterSpacing: "letter-spacing",
  lightingColor: "lighting-color",
  limitingConeAngle: "limitingconeangle",
  markerEnd: "marker-end",
  markerHeight: "markerheight",
  markerMid: "marker-mid",
  markerStart: "marker-start",
  markerUnits: "markerunits",
  markerWidth: "markerwidth",
  maskContentUnits: "maskcontentunits",
  maskUnits: "maskunits",
  numOctaves: "numoctaves",
  overlinePosition: "overline-position",
  overlineThickness: "overline-thickness",
  paintOrder: "paint-order",
  panose1: "panose-1",
  pathLength: "pathlength",
  patternContentUnits: "patterncontentunits",
  patternTransform: "patterntransform",
  patternUnits: "patternunits",
  pointerEvents: "pointer-events",
  pointsAtX: "pointsatx",
  pointsAtY: "pointsaty",
  pointsAtZ: "pointsatz",
  preserveAlpha: "preservealpha",
  preserveAspectRatio: "preserveaspectratio",
  primitiveUnits: "primitiveunits",
  refX: "refx",
  refY: "refy",
  renderingIntent: "rendering-intent",
  repeatCount: "repeatcount",
  repeatDur: "repeatdur",
  requiredExtensions: "requiredextensions",
  requiredFeatures: "requiredfeatures",
  shapeRendering: "shape-rendering",
  slot: "slot",
  specularConstant: "specularconstant",
  specularExponent: "specularexponent",
  spreadMethod: "spreadmethod",
  startOffset: "startoffset",
  stdDeviation: "stddeviation",
  stitchTiles: "stitchtiles",
  stopColor: "stop-color",
  stopOpacity: "stop-opacity",
  strikethroughPosition: "strikethrough-position",
  strikethroughThickness: "strikethrough-thickness",
  strokeDasharray: "stroke-dasharray",
  strokeDashoffset: "stroke-dashoffset",
  strokeLinecap: "stroke-linecap",
  strokeLinejoin: "stroke-linejoin",
  strokeMiterlimit: "stroke-miterlimit",
  strokeWidth: "stroke-width",
  strokeOpacity: "stroke-opacity",
  suppressContentEditableWarning: "suppresscontenteditablewarning",
  suppressHydrationWarning: "suppresshydrationwarning",
  surfaceScale: "surfacescale",
  systemLanguage: "systemlanguage",
  tableValues: "tablevalues",
  targetX: "targetx",
  targetY: "targety",
  textAnchor: "text-anchor",
  textDecoration: "text-decoration",
  textLength: "textlength",
  textRendering: "text-rendering",
  transformOrigin: "transform-origin",
  underlinePosition: "underline-position",
  underlineThickness: "underline-thickness",
  unicodeBidi: "unicode-bidi",
  unicodeRange: "unicode-range",
  unitsPerEm: "units-per-em",
  vectorEffect: "vector-effect",
  vertAdvY: "vert-adv-y",
  vertOriginX: "vert-origin-x",
  vertOriginY: "vert-origin-y",
  wordSpacing: "word-spacing",
  writingMode: "writing-mode",
  xChannelSelector: "xchannelselector",
  xHeight: "x-height",
  xlinkActuate: "xlink:actuate",
  xlinkArcrole: "xlink:arcrole",
  xlinkHref: "xlink:href",
  xlinkRole: "xlink:role",
  xlinkShow: "xlink:show",
  xlinkTitle: "xlink:title",
  xlinkType: "xlink:type",
  xmlBase: "xml:base",
  xmlLang: "xml:lang",
  xmlnsXlink: "xmlns:xlink",
  yChannelSelector: "ychannelselector",
  zoomAndPan: "zoomandpan"
};
function B({ tagName: e, defaultProps: t, defineCustomElement: o }) {
  o !== void 0 && o();
  const s = (n) => {
    const i = Object.assign(Object.assign({}, t), n), r = Object.entries(i).reduce((a, [l, c]) => {
      if (l === "dangerouslySetInnerHTML")
        return Object.assign(Object.assign({}, a), { [l]: c });
      if (cn(l))
        return Object.assign(Object.assign({}, a), { [`${ln(l)}`]: c });
      const m = mn[l];
      return m ? Object.assign(Object.assign({}, a), { [m]: c }) : Object.assign(Object.assign({}, a), { [dn(l)]: c });
    }, {});
    return M(e, Object.assign({}, r));
  };
  return s.displayName = `${an(e)}`, s;
}
const un = "cosmos-scoped-web", ue = (
  /* cosmos-scoped-web */
  { hydratedSelectorName: "hydrated", lazyLoad: !1, slotRelocation: !0, updatable: !0 }
);
var fn = Object.defineProperty, hn = (e, t) => {
  for (var o in t)
    fn(e, o, { get: t[o], enumerable: !0 });
}, pn = "http://www.w3.org/2000/svg", bn = "http://www.w3.org/1999/xhtml", ms = /* @__PURE__ */ ((e) => (e.Undefined = "undefined", e.Null = "null", e.String = "string", e.Number = "number", e.SpecialNumber = "number", e.Boolean = "boolean", e.BigInt = "bigint", e))(ms || {}), us = /* @__PURE__ */ ((e) => (e.Array = "array", e.Date = "date", e.Map = "map", e.Object = "object", e.RegularExpression = "regexp", e.Set = "set", e.Channel = "channel", e.Symbol = "symbol", e))(us || {}), it = "type", rt = "value", ht = "serialized:", ee = (e) => {
  if (e.__stencil__getHostRef)
    return e.__stencil__getHostRef();
}, gn = (e, t) => {
  const o = {
    $flags$: 0,
    $hostElement$: e,
    $cmpMeta$: t,
    $instanceValues$: /* @__PURE__ */ new Map()
  };
  o.$onReadyPromise$ = new Promise((n) => o.$onReadyResolve$ = n), e["s-p"] = [], e["s-rc"] = [];
  const s = o;
  return e.__stencil__getHostRef = () => s, s;
}, so = (e, t) => t in e, Ae = (e, t) => (0, console.error)(e, t), qe = /* @__PURE__ */ new Map(), vn = "r", xn = "o", pt = "s", _n = "t", yn = "c", ke = "s-id", bt = "sty-id", no = "c-id", wn = "slot-fb{display:contents}slot-fb[hidden]{display:none}", S = typeof window < "u" ? window : {}, j = S.HTMLElement || class {
}, A = {
  $flags$: 0,
  $resourcesUrl$: "",
  jmp: (e) => e(),
  raf: (e) => requestAnimationFrame(e),
  ael: (e, t, o, s) => e.addEventListener(t, o, s),
  rel: (e, t, o, s) => e.removeEventListener(t, o, s),
  ce: (e, t) => new CustomEvent(e, t)
}, kn = (e) => Promise.resolve(e), Pt = /* @__PURE__ */ (() => {
  try {
    return new CSSStyleSheet(), typeof new CSSStyleSheet().replaceSync == "function";
  } catch {
  }
  return !1;
})(), gt = Pt ? !!S.document && Object.getOwnPropertyDescriptor(S.document.adoptedStyleSheets, "length").writable : !1, vt = !1, io = [], fs = [], $n = (e, t) => (o) => {
  e.push(o), vt || (vt = !0, A.$flags$ & 4 ? Ve(xt) : A.raf(xt));
}, ro = (e) => {
  for (let t = 0; t < e.length; t++)
    try {
      e[t](performance.now());
    } catch (o) {
      Ae(o);
    }
  e.length = 0;
}, xt = () => {
  ro(io), ro(fs), (vt = io.length > 0) && A.raf(xt);
}, Ve = (e) => kn().then(e), zn = /* @__PURE__ */ $n(fs), Dt = (e) => (e = typeof e, e === "object" || e === "function");
function En(e) {
  var t, o, s;
  return (s = (o = (t = e.head) == null ? void 0 : t.querySelector('meta[name="csp-nonce"]')) == null ? void 0 : o.getAttribute("content")) != null ? s : void 0;
}
var Cn = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), Sn = class oe {
  /**
   * Deserializes a LocalValue serialized object back to its original JavaScript representation
   *
   * @param serialized The serialized LocalValue object
   * @returns The original JavaScript value/object
   */
  static fromLocalValue(t) {
    const o = t[it], s = rt in t ? t[rt] : void 0;
    switch (o) {
      case "string":
        return s;
      case "boolean":
        return s;
      case "bigint":
        return BigInt(s);
      case "undefined":
        return;
      case "null":
        return null;
      case "number":
        return s === "NaN" ? NaN : s === "-0" ? -0 : s === "Infinity" ? 1 / 0 : s === "-Infinity" ? -1 / 0 : s;
      case "array":
        return s.map((c) => oe.fromLocalValue(c));
      case "date":
        return new Date(s);
      case "map":
        const n = /* @__PURE__ */ new Map();
        for (const [c, m] of s) {
          const d = typeof c == "object" && c !== null ? oe.fromLocalValue(c) : c, u = oe.fromLocalValue(m);
          n.set(d, u);
        }
        return n;
      case "object":
        const i = {};
        for (const [c, m] of s)
          i[c] = oe.fromLocalValue(m);
        return i;
      case "regexp":
        const { pattern: r, flags: a } = s;
        return new RegExp(r, a);
      case "set":
        const l = /* @__PURE__ */ new Set();
        for (const c of s)
          l.add(oe.fromLocalValue(c));
        return l;
      case "symbol":
        return Symbol(s);
      default:
        throw new Error(`Unsupported type: ${o}`);
    }
  }
  /**
   * Utility method to deserialize multiple LocalValues at once
   *
   * @param serializedValues Array of serialized LocalValue objects
   * @returns Array of deserialized JavaScript values
   */
  static fromLocalValueArray(t) {
    return t.map((o) => oe.fromLocalValue(o));
  }
  /**
   * Verifies if the given object matches the structure of a serialized LocalValue
   *
   * @param obj Object to verify
   * @returns boolean indicating if the object has LocalValue structure
   */
  static isLocalValueObject(t) {
    if (typeof t != "object" || t === null || !t.hasOwnProperty(it))
      return !1;
    const o = t[it];
    return Object.values({ ...ms, ...us }).includes(o) ? o !== "null" && o !== "undefined" ? t.hasOwnProperty(rt) : !0 : !1;
  }
}, An = {};
hn(An, {
  err: () => hs,
  map: () => Tn,
  ok: () => _t,
  unwrap: () => Rn,
  unwrapErr: () => Ln
});
var _t = (e) => ({
  isOk: !0,
  isErr: !1,
  value: e
}), hs = (e) => ({
  isOk: !1,
  isErr: !0,
  value: e
});
function Tn(e, t) {
  if (e.isOk) {
    const o = t(e.value);
    return o instanceof Promise ? o.then((s) => _t(s)) : _t(o);
  }
  if (e.isErr) {
    const o = e.value;
    return hs(o);
  }
  throw "should never get here";
}
var Rn = (e) => {
  if (e.isOk)
    return e.value;
  throw e.value;
}, Ln = (e) => {
  if (e.isErr)
    return e.value;
  throw e.value;
};
function In(e) {
  return typeof e != "string" || !e.startsWith(ht) ? e : Sn.fromLocalValue(JSON.parse(atob(e.slice(ht.length))));
}
var ge;
function On(e) {
  var t;
  const o = this.attachShadow({ mode: "open" });
  ge === void 0 && (ge = (t = void 0) != null ? t : null), ge && (gt ? o.adoptedStyleSheets.push(ge) : o.adoptedStyleSheets = [...o.adoptedStyleSheets, ge]);
}
var ps = (e) => {
  const t = Q(e, "childNodes");
  e.tagName && e.tagName.includes("-") && e["s-cr"] && e.tagName !== "SLOT-FB" && bs(t, e.tagName).forEach((s) => {
    s.nodeType === 1 && s.tagName === "SLOT-FB" && (Dn(s, Ht(s), !1).length ? s.hidden = !0 : s.hidden = !1);
  });
  let o = 0;
  for (o = 0; o < t.length; o++) {
    const s = t[o];
    s.nodeType === 1 && Q(s, "childNodes").length && ps(s);
  }
}, Pn = (e) => {
  const t = [];
  for (let o = 0; o < e.length; o++) {
    const s = e[o]["s-nr"] || void 0;
    s && s.isConnected && t.push(s);
  }
  return t;
};
function bs(e, t, o) {
  let s = 0, n = [], i;
  for (; s < e.length; s++)
    i = e[s], i["s-sr"] && (!t || i["s-hn"] === t) && o === void 0 && n.push(i), n = [...n, ...bs(i.childNodes, t, o)];
  return n;
}
var Dn = (e, t, o = !0) => {
  const s = [];
  (o && e["s-sr"] || !e["s-sr"]) && s.push(e);
  let n = e;
  for (; n = n.nextSibling; )
    Ht(n) === t && (o || !n["s-sr"]) && s.push(n);
  return s;
}, ao = (e, t) => e.nodeType === 1 ? e.getAttribute("slot") === null && t === "" || e.getAttribute("slot") === t : e["s-sn"] === t ? !0 : t === "", Hn = (e, t, o, s) => {
  if (e["s-ol"] && e["s-ol"].isConnected)
    return;
  const n = document.createTextNode("");
  if (n["s-nr"] = e, !t["s-cr"] || !t["s-cr"].parentNode) return;
  const i = t["s-cr"].parentNode, r = Q(i, "appendChild");
  if (typeof s < "u") {
    n["s-oo"] = s;
    const a = Q(i, "childNodes"), l = [n];
    a.forEach((c) => {
      c["s-nr"] && l.push(c);
    }), l.sort((c, m) => !c["s-oo"] || c["s-oo"] < (m["s-oo"] || 0) ? -1 : !m["s-oo"] || m["s-oo"] < c["s-oo"] ? 1 : 0), l.forEach((c) => r.call(i, c));
  } else
    r.call(i, n);
  e["s-ol"] = n, e["s-sh"] = t["s-hn"];
}, Ht = (e) => typeof e["s-sn"] == "string" ? e["s-sn"] : e.nodeType === 1 && e.getAttribute("slot") || void 0;
function gs(e) {
  if (e.assignedElements || e.assignedNodes || !e["s-sr"]) return;
  const t = (o) => (function(s) {
    const n = [], i = this["s-sn"];
    s != null && s.flatten && console.error(`
          Flattening is not supported for Stencil non-shadow slots.
          You can use \`.childNodes\` to nested slot fallback content.
          If you have a particular use case, please open an issue on the Stencil repo.
        `);
    const r = this["s-cr"].parentElement;
    return (r.__childNodes ? r.childNodes : Pn(r.childNodes)).forEach((l) => {
      i === Ht(l) && n.push(l);
    }), o ? n.filter(
      (l) => l.nodeType === 1
      /* ElementNode */
    ) : n;
  }).bind(e);
  e.assignedElements = t(!0), e.assignedNodes = t(!1);
}
function Q(e, t) {
  if ("__" + t in e) {
    const o = e["__" + t];
    return typeof o != "function" ? o : o.bind(e);
  } else
    return typeof e[t] != "function" ? e[t] : e[t].bind(e);
}
var te = (e, t = "") => () => {
}, ce = /* @__PURE__ */ new WeakMap(), vs = (e, t, o) => {
  let s = qe.get(e);
  Pt && o ? (s = s || new CSSStyleSheet(), typeof s == "string" ? s = t : s.replaceSync(t)) : s = t, qe.set(e, s);
}, xs = (e, t, o) => {
  var s;
  const n = jt(t), i = qe.get(n);
  if (!S.document)
    return n;
  if (e = e.nodeType === 11 ? e : S.document, i)
    if (typeof i == "string") {
      e = e.head || e;
      let r = ce.get(e), a;
      if (r || ce.set(e, r = /* @__PURE__ */ new Set()), !r.has(n)) {
        if (e.host && (a = e.querySelector(`[${bt}="${n}"]`)))
          a.innerHTML = i;
        else {
          a = S.document.createElement("style"), a.innerHTML = i;
          const l = (s = A.$nonce$) != null ? s : En(S.document);
          if (l != null && a.setAttribute("nonce", l), !(t.$flags$ & 1))
            if (e.nodeName === "HEAD") {
              const c = e.querySelectorAll("link[rel=preconnect]"), m = c.length > 0 ? c[c.length - 1].nextSibling : e.querySelector("style");
              e.insertBefore(
                a,
                (m == null ? void 0 : m.parentNode) === e ? m : null
              );
            } else if ("host" in e)
              if (Pt) {
                const c = new CSSStyleSheet();
                c.replaceSync(i), gt ? e.adoptedStyleSheets.unshift(c) : e.adoptedStyleSheets = [c, ...e.adoptedStyleSheets];
              } else {
                const c = e.querySelector("style");
                c ? c.innerHTML = i + c.innerHTML : e.prepend(a);
              }
            else
              e.append(a);
          t.$flags$ & 1 && e.insertBefore(a, null);
        }
        t.$flags$ & 4 && (a.innerHTML += wn), r && r.add(n);
      }
    } else e.adoptedStyleSheets.includes(i) || (gt ? e.adoptedStyleSheets.push(i) : e.adoptedStyleSheets = [...e.adoptedStyleSheets, i]);
  return n;
}, jn = (e) => {
  const t = e.$cmpMeta$, o = e.$hostElement$, s = t.$flags$, n = te("attachStyles", t.$tagName$), i = xs(
    o.shadowRoot ? o.shadowRoot : o.getRootNode(),
    t
  );
  s & 10 && (o["s-sc"] = i, o.classList.add(i + "-h")), n();
}, jt = (e, t) => "sc-" + e.$tagName$, Fn = (e) => e.replace(/\/\*!@([^\/]+)\*\/[^\{]+\{/g, "$1{"), Bn = () => {
  if (!S.document)
    return;
  const e = S.document.querySelectorAll(`[${bt}]`);
  let t = 0;
  for (; t < e.length; t++)
    vs(e[t].getAttribute(bt), Fn(e[t].innerHTML), !0);
}, v = (e, t, ...o) => {
  let s = null, n = null, i = null, r = !1, a = !1;
  const l = [], c = (d) => {
    for (let u = 0; u < d.length; u++)
      s = d[u], Array.isArray(s) ? c(s) : s != null && typeof s != "boolean" && ((r = typeof e != "function" && !Dt(s)) && (s = String(s)), r && a ? l[l.length - 1].$text$ += s : l.push(r ? fe(null, s) : s), a = r);
  };
  if (c(o), t) {
    t.key && (n = t.key), t.name && (i = t.name);
    {
      const d = t.className || t.class;
      d && (t.class = typeof d != "object" ? d : Object.keys(d).filter((u) => d[u]).join(" "));
    }
  }
  if (typeof e == "function")
    return e(
      t === null ? {} : t,
      l,
      Nn
    );
  const m = fe(e, null);
  return m.$attrs$ = t, l.length > 0 && (m.$children$ = l), m.$key$ = n, m.$name$ = i, m;
}, fe = (e, t) => {
  const o = {
    $flags$: 0,
    $tag$: e,
    $text$: t,
    $elm$: null,
    $children$: null
  };
  return o.$attrs$ = null, o.$key$ = null, o.$name$ = null, o;
}, q = {}, Un = (e) => e && e.$tag$ === q, Nn = {
  forEach: (e, t) => e.map(co).forEach(t),
  map: (e, t) => e.map(co).map(t).map(Mn)
}, co = (e) => ({
  vattrs: e.$attrs$,
  vchildren: e.$children$,
  vkey: e.$key$,
  vname: e.$name$,
  vtag: e.$tag$,
  vtext: e.$text$
}), Mn = (e) => {
  if (typeof e.vtag == "function") {
    const o = { ...e.vattrs };
    return e.vkey && (o.key = e.vkey), e.vname && (o.name = e.vname), v(e.vtag, o, ...e.vchildren || []);
  }
  const t = fe(e.vtag, e.vtext);
  return t.$attrs$ = e.vattrs, t.$children$ = e.vchildren, t.$key$ = e.vkey, t.$name$ = e.vname, t;
}, qn = (e, t, o, s) => {
  var n, i, r;
  const a = te("hydrateClient", t), l = e.shadowRoot, c = [], m = [], d = [], u = l ? [] : null, f = fe(t, null);
  f.$elm$ = e, Object.entries(((n = s.$cmpMeta$) == null ? void 0 : n.$members$) || {}).forEach(([$, [T, _]]) => {
    var z;
    if (!(T & 31))
      return;
    const J = _ || $, Z = e.getAttribute(J);
    if (Z !== null) {
      const ot = Bt(
        Z,
        T
      );
      (z = s == null ? void 0 : s.$instanceValues$) == null || z.set($, ot);
    }
  }), S.document && (!A.$orgLocNodes$ || !A.$orgLocNodes$.size) && wt(S.document.body, A.$orgLocNodes$ = /* @__PURE__ */ new Map()), e[ke] = o, e.removeAttribute(ke), s.$vnode$ = yt(
    f,
    c,
    m,
    u,
    e,
    e,
    o,
    d
  );
  let b = 0;
  const x = c.length;
  let h;
  for (b; b < x; b++) {
    h = c[b];
    const $ = h.$hostId$ + "." + h.$nodeId$, T = A.$orgLocNodes$.get($), _ = h.$elm$;
    if (!l)
      _["s-hn"] = t.toUpperCase(), h.$tag$ === "slot" && (_["s-cr"] = e["s-cr"]);
    else if ((i = h.$tag$) != null && i.toString().includes("-") && h.$tag$ !== "slot-fb" && !h.$elm$.shadowRoot) {
      const z = ee(h.$elm$);
      if (z) {
        const J = jt(
          z.$cmpMeta$
        ), Z = S.document.querySelector(`style[sty-id="${J}"]`);
        Z && e.shadowRoot.append(Z.cloneNode(!0));
      }
    }
    h.$tag$ === "slot" && (h.$name$ = h.$elm$["s-sn"] || h.$elm$.name || null, h.$children$ ? (h.$flags$ |= 2, h.$elm$.childNodes.length || h.$children$.forEach((z) => {
      h.$elm$.appendChild(z.$elm$);
    })) : h.$flags$ |= 1), T && T.isConnected && (T.parentElement.shadowRoot && T["s-en"] === "" && T.parentNode.insertBefore(_, T.nextSibling), T.parentNode.removeChild(T), l || (_["s-oo"] = parseInt(h.$nodeId$))), T && !T["s-id"] && A.$orgLocNodes$.delete($);
  }
  const y = [], E = d.length;
  let k = 0, L, D, X, C;
  for (k; k < E; k++)
    if (L = d[k], !(!L || !L.length))
      for (X = L.length, D = 0, D; D < X; D++) {
        if (C = L[D], y[C.hostId] || (y[C.hostId] = A.$orgLocNodes$.get(C.hostId)), !y[C.hostId]) continue;
        const $ = y[C.hostId];
        $.shadowRoot && C.node.parentElement !== $ && $.appendChild(C.node), (!$.shadowRoot || !l) && (C.slot["s-cr"] || (C.slot["s-cr"] = $["s-cr"], !C.slot["s-cr"] && $.shadowRoot ? C.slot["s-cr"] = $ : C.slot["s-cr"] = ($.__childNodes || $.childNodes)[0]), Hn(C.node, C.slot, !1, C.node["s-oo"]), (r = C.node.parentElement) != null && r.shadowRoot && C.node.getAttribute && C.node.getAttribute("slot") && C.node.removeAttribute("slot"));
      }
  if (l) {
    let $ = 0;
    const T = u.length;
    if (T) {
      for ($; $ < T; $++) {
        const _ = u[$];
        _ && l.appendChild(_);
      }
      Array.from(e.childNodes).forEach((_) => {
        typeof _["s-en"] != "string" && typeof _["s-sn"] != "string" && (_.nodeType === 1 && _.slot && _.hidden ? _.removeAttribute("hidden") : (_.nodeType === 8 && !_.nodeValue || _.nodeType === 3 && !_.wholeText.trim()) && _.parentNode.removeChild(_));
      });
    }
  }
  s.$hostElement$ = e, a();
}, yt = (e, t, o, s, n, i, r, a = []) => {
  let l, c, m, d;
  if (i.nodeType === 1) {
    if (l = i.getAttribute(no), l && (c = l.split("."), c[0] === r || c[0] === "0")) {
      m = lo({
        $flags$: 0,
        $hostId$: c[0],
        $nodeId$: c[1],
        $depth$: c[2],
        $index$: c[3],
        $tag$: i.tagName.toLowerCase(),
        $elm$: i,
        // If we don't add the initial classes to the VNode, the first `vdom-render.ts` patch
        // won't try to reconcile them. Classes set on the node will be blown away.
        $attrs$: { class: i.className || "" }
      }), t.push(m), i.removeAttribute(no), e.$children$ || (e.$children$ = []);
      const f = m.$elm$.getAttribute("s-sn");
      typeof f == "string" && (m.$tag$ === "slot-fb" && mo(
        f,
        c[2],
        m,
        i,
        e,
        t,
        o,
        s,
        a
      ), m.$elm$["s-sn"] = f, m.$elm$.removeAttribute("s-sn")), m.$index$ !== void 0 && (e.$children$[m.$index$] = m), e = m, s && m.$depth$ === "0" && (s[m.$index$] = m.$elm$);
    }
    if (i.shadowRoot)
      for (d = i.shadowRoot.childNodes.length - 1; d >= 0; d--)
        yt(
          e,
          t,
          o,
          s,
          n,
          i.shadowRoot.childNodes[d],
          r,
          a
        );
    const u = i.__childNodes || i.childNodes;
    for (d = u.length - 1; d >= 0; d--)
      yt(
        e,
        t,
        o,
        s,
        n,
        u[d],
        r,
        a
      );
  } else if (i.nodeType === 8) {
    if (c = i.nodeValue.split("."), c[1] === r || c[1] === "0") {
      if (l = c[0], m = lo({
        $hostId$: c[1],
        $nodeId$: c[2],
        $depth$: c[3],
        $index$: c[4] || "0",
        $elm$: i,
        $attrs$: null,
        $children$: null,
        $key$: null,
        $name$: null,
        $tag$: null,
        $text$: null
      }), l === _n)
        m.$elm$ = fo(
          i,
          3
          /* TextNode */
        ), m.$elm$ && m.$elm$.nodeType === 3 && (m.$text$ = m.$elm$.textContent, t.push(m), i.remove(), r === m.$hostId$ && (e.$children$ || (e.$children$ = []), e.$children$[m.$index$] = m), s && m.$depth$ === "0" && (s[m.$index$] = m.$elm$));
      else if (l === yn)
        m.$elm$ = fo(
          i,
          8
          /* CommentNode */
        ), m.$elm$ && m.$elm$.nodeType === 8 && (t.push(m), i.remove());
      else if (m.$hostId$ === r)
        if (l === pt) {
          const u = i["s-sn"] = c[5] || "";
          mo(
            u,
            c[2],
            m,
            i,
            e,
            t,
            o,
            s,
            a
          );
        } else l === vn && (s ? i.remove() : (n["s-cr"] = i, i["s-cn"] = !0));
    }
  } else if (e && e.$tag$ === "style") {
    const u = fe(null, i.textContent);
    u.$elm$ = i, u.$index$ = "0", e.$children$ = [u];
  } else
    i.nodeType === 3 && !i.wholeText.trim() && !i["s-nr"] && i.remove();
  return e;
}, wt = (e, t) => {
  if (e.nodeType === 1) {
    const o = e[ke] || e.getAttribute(ke);
    o && t.set(o, e);
    let s = 0;
    if (e.shadowRoot)
      for (; s < e.shadowRoot.childNodes.length; s++)
        wt(e.shadowRoot.childNodes[s], t);
    const n = e.__childNodes || e.childNodes;
    for (s = 0; s < n.length; s++)
      wt(n[s], t);
  } else if (e.nodeType === 8) {
    const o = e.nodeValue.split(".");
    o[0] === xn && (t.set(o[1] + "." + o[2], e), e.nodeValue = "", e["s-en"] = o[3]);
  }
}, lo = (e) => ({ ...{
  $flags$: 0,
  $hostId$: null,
  $nodeId$: null,
  $depth$: null,
  $index$: "0",
  $elm$: null,
  $attrs$: null,
  $children$: null,
  $key$: null,
  $name$: null,
  $tag$: null,
  $text$: null
}, ...e });
function mo(e, t, o, s, n, i, r, a, l) {
  s["s-sr"] = !0, o.$name$ = e || null, o.$tag$ = "slot";
  const c = n != null && n.$elm$ ? n.$elm$["s-id"] || n.$elm$.getAttribute("s-id") : "";
  if (a && S.document) {
    const m = o.$elm$ = S.document.createElement(o.$tag$);
    o.$name$ && o.$elm$.setAttribute("name", e), n.$elm$.shadowRoot && c && c !== o.$hostId$ ? Q(n.$elm$, "insertBefore")(m, Q(n.$elm$, "children")[0]) : Q(Q(s, "parentNode"), "insertBefore")(m, s), uo(l, t, e, s, o.$hostId$), s.remove(), o.$depth$ === "0" && (a[o.$index$] = o.$elm$);
  } else {
    const m = o.$elm$, d = c && c !== o.$hostId$ && n.$elm$.shadowRoot;
    uo(l, t, e, s, d ? c : o.$hostId$), gs(s), d && n.$elm$.insertBefore(m, n.$elm$.children[0]);
  }
  i.push(o), r.push(o), n.$children$ || (n.$children$ = []), n.$children$[o.$index$] = o;
}
var uo = (e, t, o, s, n) => {
  var i, r;
  let a = s.nextSibling;
  if (e[t] = e[t] || [], !(!a || (i = a.nodeValue) != null && i.startsWith(pt + ".")))
    do
      a && ((a.getAttribute && a.getAttribute("slot") || a["s-sn"]) === o || o === "" && !a["s-sn"] && (!a.getAttribute || !a.getAttribute("slot")) && (a.nodeType === 8 || a.nodeType === 3)) && (a["s-sn"] = o, e[t].push({ slot: s, node: a, hostId: n })), a = a == null ? void 0 : a.nextSibling;
    while (a && !((r = a.nodeValue) != null && r.startsWith(pt + ".")));
}, fo = (e, t) => {
  let o = e;
  do
    o = o.nextSibling;
  while (o && (o.nodeType !== t || !o.nodeValue));
  return o;
}, Ft = (e) => {
  const t = Cn(e);
  return new RegExp(
    // First capture group: match any context before the selector that's not inside @supports selector()
    // Using negative lookahead to avoid matching inside @supports selector(...) condition
    `(^|[^@]|@(?!supports\\s+selector\\s*\\([^{]*?${t}))(${t}\\b)`,
    "g"
  );
};
Ft("::slotted");
Ft(":host");
Ft(":host-context");
var Bt = (e, t, o) => {
  if (typeof e == "string" && (e.startsWith("{") && e.endsWith("}") || e.startsWith("[") && e.endsWith("]")))
    try {
      return e = JSON.parse(e), e;
    } catch {
    }
  return typeof e == "string" && e.startsWith(ht) ? (e = In(e), e) : e != null && !Dt(e) ? t & 4 ? e === "false" ? !1 : e === "" || !!e : t & 2 ? typeof e == "string" ? parseFloat(e) : typeof e == "number" ? e : NaN : t & 1 ? String(e) : e : e;
}, Gn = (e) => e, Wn = (e, t, o) => {
  const s = Gn(e);
  return {
    emit: (n) => _s(s, t, {
      bubbles: !0,
      composed: !1,
      cancelable: !0,
      detail: n
    })
  };
}, _s = (e, t, o) => {
  const s = A.ce(t, o);
  return e.dispatchEvent(s), s;
}, ho = (e, t, o, s, n, i, r) => {
  if (o === s)
    return;
  let a = so(e, t), l = t.toLowerCase();
  if (t === "class") {
    const c = e.classList, m = po(o);
    let d = po(s);
    if ((e["s-si"] || e["s-sc"]) && r) {
      const u = e["s-sc"] || e["s-si"];
      d.push(u), m.forEach((f) => {
        f.startsWith(u) && d.push(f);
      }), d = [...new Set(d)].filter((f) => f), c.add(...d);
    } else
      c.remove(...m.filter((u) => u && !d.includes(u))), c.add(...d.filter((u) => u && !m.includes(u)));
  } else if (t === "style") {
    for (const c in o)
      (!s || s[c] == null) && (c.includes("-") ? e.style.removeProperty(c) : e.style[c] = "");
    for (const c in s)
      (!o || s[c] !== o[c]) && (c.includes("-") ? e.style.setProperty(c, s[c]) : e.style[c] = s[c]);
  } else if (t !== "key") if (t === "ref")
    s && s(e);
  else if (!e.__lookupSetter__(t) && t[0] === "o" && t[1] === "n") {
    if (t[2] === "-" ? t = t.slice(3) : so(S, l) ? t = l.slice(2) : t = l[2] + t.slice(3), o || s) {
      const c = t.endsWith(ys);
      t = t.replace(Xn, ""), o && A.rel(e, t, o, c), s && A.ael(e, t, s, c);
    }
  } else {
    const c = Dt(s);
    if ((a || c && s !== null) && !n)
      try {
        if (e.tagName.includes("-"))
          e[t] !== s && (e[t] = s);
        else {
          const m = s ?? "";
          t === "list" ? a = !1 : (o == null || e[t] != m) && (typeof e.__lookupSetter__(t) == "function" ? e[t] = m : e.setAttribute(t, m));
        }
      } catch {
      }
    s == null || s === !1 ? (s !== !1 || e.getAttribute(t) === "") && e.removeAttribute(t) : (!a || i & 4 || n) && !c && e.nodeType === 1 && (s = s === !0 ? "" : s, e.setAttribute(t, s));
  }
}, Yn = /\s/, po = (e) => (typeof e == "object" && e && "baseVal" in e && (e = e.baseVal), !e || typeof e != "string" ? [] : e.split(Yn)), ys = "Capture", Xn = new RegExp(ys + "$"), kt = (e, t, o, s) => {
  const n = t.$elm$.nodeType === 11 && t.$elm$.host ? t.$elm$.host : t.$elm$, i = e && e.$attrs$ || {}, r = t.$attrs$ || {};
  for (const a of bo(Object.keys(i)))
    a in r || ho(
      n,
      a,
      i[a],
      void 0,
      o,
      t.$flags$,
      s
    );
  for (const a of bo(Object.keys(r)))
    ho(
      n,
      a,
      i[a],
      r[a],
      o,
      t.$flags$,
      s
    );
};
function bo(e) {
  return e.includes("ref") ? (
    // we need to sort these to ensure that `'ref'` is the last attr
    [...e.filter((t) => t !== "ref"), "ref"]
  ) : (
    // no need to sort, return the original array
    e
  );
}
var $t, et, zt = !1, Ge = !1, Ut = !1, P = !1, We = (e, t, o) => {
  var s;
  const n = t.$children$[o];
  let i = 0, r, a, l;
  if (zt || (Ut = !0, n.$tag$ === "slot" && (n.$flags$ |= n.$children$ ? (
    // slot element has fallback content
    // still create an element that "mocks" the slot element
    2
  ) : (
    // slot element does not have fallback content
    // create an html comment we'll use to always reference
    // where actual slot content should sit next to
    1
  ))), n.$text$ !== null)
    r = n.$elm$ = S.document.createTextNode(n.$text$);
  else if (n.$flags$ & 1)
    r = n.$elm$ = S.document.createTextNode(""), kt(null, n, P);
  else {
    if (P || (P = n.$tag$ === "svg"), !S.document)
      throw new Error(
        "You are trying to render a Stencil component in an environment that doesn't support the DOM. Make sure to populate the [`window`](https://developer.mozilla.org/en-US/docs/Web/API/Window/window) object before rendering a component."
      );
    if (r = n.$elm$ = S.document.createElementNS(
      P ? pn : bn,
      !zt && ue.slotRelocation && n.$flags$ & 2 ? "slot-fb" : n.$tag$
    ), P && n.$tag$ === "foreignObject" && (P = !1), kt(null, n, P), n.$children$)
      for (i = 0; i < n.$children$.length; ++i)
        a = We(e, n, i), a && r.appendChild(a);
    n.$tag$ === "svg" ? P = !1 : r.tagName === "foreignObject" && (P = !0);
  }
  return r["s-hn"] = et, n.$flags$ & 3 && (r["s-sr"] = !0, r["s-cr"] = $t, r["s-sn"] = n.$name$ || "", r["s-rf"] = (s = n.$attrs$) == null ? void 0 : s.ref, gs(r), l = e && e.$children$ && e.$children$[o], l && l.$tag$ === n.$tag$ && e.$elm$ && $e(e.$elm$, !1)), r;
}, $e = (e, t) => {
  A.$flags$ |= 1;
  const o = Array.from(e.__childNodes || e.childNodes);
  for (let s = o.length - 1; s >= 0; s--) {
    const n = o[s];
    n["s-hn"] !== et && n["s-ol"] && (V(ze(n).parentNode, n, ze(n)), n["s-ol"].remove(), n["s-ol"] = void 0, n["s-sh"] = void 0, Ut = !0), t && $e(n, t);
  }
  A.$flags$ &= -2;
}, ws = (e, t, o, s, n, i) => {
  let r = e["s-cr"] && e["s-cr"].parentNode || e, a;
  for (r.shadowRoot && r.tagName === et && (r = r.shadowRoot); n <= i; ++n)
    s[n] && (a = We(null, o, n), a && (s[n].$elm$ = a, V(r, a, ze(t))));
}, ks = (e, t, o) => {
  for (let s = t; s <= o; ++s) {
    const n = e[s];
    if (n) {
      const i = n.$elm$;
      zs(n), i && (Ge = !0, i["s-ol"] ? i["s-ol"].remove() : $e(i, !0), i.remove());
    }
  }
}, Jn = (e, t, o, s, n = !1) => {
  let i = 0, r = 0, a = 0, l = 0, c = t.length - 1, m = t[0], d = t[c], u = s.length - 1, f = s[0], g = s[u], b, x;
  for (; i <= c && r <= u; )
    if (m == null)
      m = t[++i];
    else if (d == null)
      d = t[--c];
    else if (f == null)
      f = s[++r];
    else if (g == null)
      g = s[--u];
    else if (Ie(m, f, n))
      re(m, f, n), m = t[++i], f = s[++r];
    else if (Ie(d, g, n))
      re(d, g, n), d = t[--c], g = s[--u];
    else if (Ie(m, g, n))
      (m.$tag$ === "slot" || g.$tag$ === "slot") && $e(m.$elm$.parentNode, !1), re(m, g, n), V(e, m.$elm$, d.$elm$.nextSibling), m = t[++i], g = s[--u];
    else if (Ie(d, f, n))
      (m.$tag$ === "slot" || g.$tag$ === "slot") && $e(d.$elm$.parentNode, !1), re(d, f, n), V(e, d.$elm$, m.$elm$), d = t[--c], f = s[++r];
    else {
      for (a = -1, l = i; l <= c; ++l)
        if (t[l] && t[l].$key$ !== null && t[l].$key$ === f.$key$) {
          a = l;
          break;
        }
      a >= 0 ? (x = t[a], x.$tag$ !== f.$tag$ ? b = We(t && t[r], o, a) : (re(x, f, n), t[a] = void 0, b = x.$elm$), f = s[++r]) : (b = We(t && t[r], o, r), f = s[++r]), b && V(
        ze(m.$elm$).parentNode,
        b,
        ze(m.$elm$)
      );
    }
  i > c ? ws(
    e,
    s[u + 1] == null ? null : s[u + 1].$elm$,
    o,
    s,
    r,
    u
  ) : r > u && ks(t, i, c);
}, Ie = (e, t, o = !1) => e.$tag$ === t.$tag$ ? e.$tag$ === "slot" ? e.$name$ === t.$name$ : o ? (o && !e.$key$ && t.$key$ && (e.$key$ = t.$key$), !0) : e.$key$ === t.$key$ : !1, ze = (e) => e && e["s-ol"] || e, re = (e, t, o = !1) => {
  const s = t.$elm$ = e.$elm$, n = e.$children$, i = t.$children$, r = t.$tag$, a = t.$text$;
  let l;
  a === null ? (P = r === "svg" ? !0 : r === "foreignObject" ? !1 : P, kt(e, t, P, o), n !== null && i !== null ? Jn(s, n, t, i, o) : i !== null ? (e.$text$ !== null && (s.textContent = ""), ws(s, null, t, i, 0, i.length - 1)) : /* don't do this on initial render as it can cause non-hydrated content to be removed */ !o && ue.updatable && n !== null ? ks(n, 0, n.length - 1) : o && ue.updatable && n !== null && i === null && (t.$children$ = n), P && r === "svg" && (P = !1)) : (l = s["s-cr"]) ? l.parentNode.textContent = a : e.$text$ !== a && (s.data = a);
}, G = [], $s = (e) => {
  let t, o, s;
  const n = e.__childNodes || e.childNodes;
  for (const i of n) {
    if (i["s-sr"] && (t = i["s-cr"]) && t.parentNode) {
      o = t.parentNode.__childNodes || t.parentNode.childNodes;
      const r = i["s-sn"];
      for (s = o.length - 1; s >= 0; s--)
        if (t = o[s], !t["s-cn"] && !t["s-nr"] && t["s-hn"] !== i["s-hn"])
          if (ao(t, r)) {
            let a = G.find((l) => l.$nodeToRelocate$ === t);
            Ge = !0, t["s-sn"] = t["s-sn"] || r, a ? (a.$nodeToRelocate$["s-sh"] = i["s-hn"], a.$slotRefNode$ = i) : (t["s-sh"] = i["s-hn"], G.push({
              $slotRefNode$: i,
              $nodeToRelocate$: t
            })), t["s-sr"] && G.map((l) => {
              ao(l.$nodeToRelocate$, t["s-sn"]) && (a = G.find((c) => c.$nodeToRelocate$ === t), a && !l.$slotRefNode$ && (l.$slotRefNode$ = a.$slotRefNode$));
            });
          } else G.some((a) => a.$nodeToRelocate$ === t) || G.push({
            $nodeToRelocate$: t
          });
    }
    i.nodeType === 1 && $s(i);
  }
}, zs = (e) => {
  e.$attrs$ && e.$attrs$.ref && e.$attrs$.ref(null), e.$children$ && e.$children$.map(zs);
}, V = (e, t, o) => e == null ? void 0 : e.insertBefore(t, o), Zn = (e, t, o = !1) => {
  var s, n, i, r;
  const a = e.$hostElement$, l = e.$cmpMeta$, c = e.$vnode$ || fe(null, null), d = Un(t) ? t : v(null, null, t);
  if (et = a.tagName, l.$attrsToReflect$ && (d.$attrs$ = d.$attrs$ || {}, l.$attrsToReflect$.map(
    ([u, f]) => d.$attrs$[f] = a[u]
  )), o && d.$attrs$)
    for (const u of Object.keys(d.$attrs$))
      a.hasAttribute(u) && !["key", "ref", "style", "class"].includes(u) && (d.$attrs$[u] = a[u]);
  d.$tag$ = null, d.$flags$ |= 4, e.$vnode$ = d, d.$elm$ = c.$elm$ = a.shadowRoot || a, zt = !!(l.$flags$ & 1) && !(l.$flags$ & 128), $t = a["s-cr"], Ge = !1, re(c, d, o);
  {
    if (A.$flags$ |= 1, Ut) {
      $s(d.$elm$);
      for (const u of G) {
        const f = u.$nodeToRelocate$;
        if (!f["s-ol"] && S.document) {
          const g = S.document.createTextNode("");
          g["s-nr"] = f, V(f.parentNode, f["s-ol"] = g, f);
        }
      }
      for (const u of G) {
        const f = u.$nodeToRelocate$, g = u.$slotRefNode$;
        if (g) {
          const b = g.parentNode;
          let x = g.nextSibling;
          {
            let E = (s = f["s-ol"]) == null ? void 0 : s.previousSibling;
            for (; E; ) {
              let k = (n = E["s-nr"]) != null ? n : null;
              if (k && k["s-sn"] === f["s-sn"] && b === (k.__parentNode || k.parentNode)) {
                for (k = k.nextSibling; k === f || k != null && k["s-sr"]; )
                  k = k == null ? void 0 : k.nextSibling;
                if (!k || !k["s-nr"]) {
                  x = k;
                  break;
                }
              }
              E = E.previousSibling;
            }
          }
          const h = f.__parentNode || f.parentNode, y = f.__nextSibling || f.nextSibling;
          (!x && b !== h || y !== x) && f !== x && (!f["s-hn"] && f["s-ol"] && (f["s-hn"] = f["s-ol"].parentNode.nodeName), V(b, f, x), f.nodeType === 1 && f.tagName !== "SLOT-FB" && (f.hidden = (i = f["s-ih"]) != null ? i : !1)), f && typeof g["s-rf"] == "function" && g["s-rf"](g);
        } else
          f.nodeType === 1 && (o && (f["s-ih"] = (r = f.hidden) != null ? r : !1), f.hidden = !0);
      }
    }
    Ge && ps(d.$elm$), A.$flags$ &= -2, G.length = 0;
  }
  $t = void 0;
}, Es = (e, t) => {
  if (t && !e.$onRenderResolve$ && t["s-p"]) {
    const o = t["s-p"].push(
      new Promise(
        (s) => e.$onRenderResolve$ = () => {
          t["s-p"].splice(o - 1, 1), s();
        }
      )
    );
  }
}, Nt = (e, t) => {
  if (e.$flags$ |= 16, e.$flags$ & 4) {
    e.$flags$ |= 512;
    return;
  }
  Es(e, e.$ancestorComponent$);
  const o = () => Qn(e, t);
  if (t) {
    queueMicrotask(() => {
      o();
    });
    return;
  }
  return zn(o);
}, Qn = (e, t) => {
  const o = e.$hostElement$, s = te("scheduleUpdate", e.$cmpMeta$.$tagName$), n = o;
  if (!n)
    throw new Error(
      `Can't render component <${o.tagName.toLowerCase()} /> with invalid Stencil runtime! Make sure this imported component is compiled with a \`externalRuntime: true\` flag. For more information, please refer to https://stenciljs.com/docs/custom-elements#externalruntime`
    );
  let i;
  return t ? i = le(n, "componentWillLoad", void 0, o) : i = le(n, "componentWillUpdate", void 0, o), i = go(i, () => le(n, "componentWillRender", void 0, o)), s(), go(i, () => Vn(e, n, t));
}, go = (e, t) => Kn(e) ? e.then(t).catch((o) => {
  console.error(o), t();
}) : t(), Kn = (e) => e instanceof Promise || e && e.then && typeof e.then == "function", Vn = async (e, t, o) => {
  var s;
  const n = e.$hostElement$, i = te("update", e.$cmpMeta$.$tagName$), r = n["s-rc"];
  o && jn(e);
  const a = te("render", e.$cmpMeta$.$tagName$);
  ei(e, t, n, o), r && (r.map((l) => l()), n["s-rc"] = void 0), a(), i();
  {
    const l = (s = n["s-p"]) != null ? s : [], c = () => ti(e);
    l.length === 0 ? c() : (Promise.all(l).then(c), e.$flags$ |= 4, l.length = 0);
  }
}, ei = (e, t, o, s) => {
  try {
    t = t.render(), e.$flags$ &= -17, e.$flags$ |= 2, Zn(e, t, s);
  } catch (n) {
    Ae(n, e.$hostElement$);
  }
  return null;
}, ti = (e) => {
  const t = e.$cmpMeta$.$tagName$, o = e.$hostElement$, s = te("postUpdate", t), n = o, i = e.$ancestorComponent$;
  le(n, "componentDidRender", void 0, o), e.$flags$ & 64 ? (le(n, "componentDidUpdate", void 0, o), s()) : (e.$flags$ |= 64, si(o), le(n, "componentDidLoad", void 0, o), s(), e.$onReadyResolve$(o), i || oi()), e.$onRenderResolve$ && (e.$onRenderResolve$(), e.$onRenderResolve$ = void 0), e.$flags$ & 512 && Ve(() => Nt(e, !1)), e.$flags$ &= -517;
}, oi = (e) => {
  var t;
  Ve(() => _s(S, "appload", { detail: { namespace: un } })), (t = A.$orgLocNodes$) != null && t.size && A.$orgLocNodes$.clear();
}, le = (e, t, o, s) => {
  if (e && e[t])
    try {
      return e[t](o);
    } catch (n) {
      Ae(n, s);
    }
}, si = (e) => {
  var t;
  return e.classList.add((t = ue.hydratedSelectorName) != null ? t : "hydrated");
}, ni = (e, t) => ee(e).$instanceValues$.get(t), vo = (e, t, o, s) => {
  const n = ee(e);
  if (!n)
    return;
  const i = e, r = n.$instanceValues$.get(t), a = n.$flags$, l = i;
  o = Bt(
    o,
    s.$members$[t][0]
  );
  const c = Number.isNaN(r) && Number.isNaN(o);
  if (o !== r && !c) {
    n.$instanceValues$.set(t, o);
    {
      if (s.$watchers$ && a & 128) {
        const d = s.$watchers$[t];
        d && d.map((u) => {
          try {
            l[u](o, r, t);
          } catch (f) {
            Ae(f, i);
          }
        });
      }
      if ((a & 18) === 2) {
        if (l.componentShouldUpdate && l.componentShouldUpdate(o, r, t) === !1)
          return;
        Nt(n, !1);
      }
    }
  }
}, ii = (e, t, o) => {
  var s, n;
  const i = e.prototype;
  if (t.$members$ || t.$watchers$ || e.watchers) {
    e.watchers && !t.$watchers$ && (t.$watchers$ = e.watchers);
    const r = Object.entries((s = t.$members$) != null ? s : {});
    r.map(([a, [l]]) => {
      if (l & 31 || l & 32) {
        const { get: c, set: m } = Object.getOwnPropertyDescriptor(i, a) || {};
        c && (t.$members$[a][0] |= 2048), m && (t.$members$[a][0] |= 4096), Object.defineProperty(i, a, {
          get() {
            return c ? c.apply(this) : ni(this, a);
          },
          configurable: !0,
          enumerable: !0
        }), Object.defineProperty(i, a, {
          set(d) {
            const u = ee(this);
            if (u) {
              if (m) {
                const f = l & 32 ? this[a] : u.$hostElement$[a];
                typeof f > "u" && u.$instanceValues$.get(a) ? d = u.$instanceValues$.get(a) : !u.$instanceValues$.get(a) && f && u.$instanceValues$.set(a, f), m.apply(this, [
                  Bt(
                    d,
                    l
                  )
                ]), d = l & 32 ? this[a] : u.$hostElement$[a], vo(this, a, d, t);
                return;
              }
              {
                vo(this, a, d, t);
                return;
              }
            }
          }
        });
      }
    });
    {
      const a = /* @__PURE__ */ new Map();
      i.attributeChangedCallback = function(l, c, m) {
        A.jmp(() => {
          var d;
          const u = a.get(l);
          if (!(this.hasOwnProperty(u) && ue.lazyLoad)) {
            if (i.hasOwnProperty(u) && typeof this[u] == "number" && // cast type to number to avoid TS compiler issues
            this[u] == m)
              return;
            if (u == null) {
              const g = ee(this), b = g == null ? void 0 : g.$flags$;
              if (g && b && !(b & 8) && b & 128 && m !== c) {
                const h = this, y = (d = t.$watchers$) == null ? void 0 : d[l];
                y == null || y.forEach((E) => {
                  h[E] != null && h[E].call(h, m, c, l);
                });
              }
              return;
            }
          }
          const f = Object.getOwnPropertyDescriptor(i, u);
          m = m === null && typeof this[u] == "boolean" ? !1 : m, m !== this[u] && (!f.get || f.set) && (this[u] = m);
        });
      }, e.observedAttributes = Array.from(
        /* @__PURE__ */ new Set([
          ...Object.keys((n = t.$watchers$) != null ? n : {}),
          ...r.filter(
            ([l, c]) => c[0] & 15
            /* HasAttribute */
          ).map(([l, c]) => {
            var m;
            const d = c[1] || l;
            return a.set(d, l), c[0] & 512 && ((m = t.$attrsToReflect$) == null || m.push([l, d])), d;
          })
        ])
      );
    }
  }
  return e;
}, xo = async (e, t, o, s) => {
  let n;
  if (!(t.$flags$ & 32)) {
    t.$flags$ |= 32;
    {
      n = e.constructor;
      const a = e.localName;
      customElements.whenDefined(a).then(
        () => t.$flags$ |= 128
        /* isWatchReady */
      );
    }
    if (n && n.style) {
      let a;
      typeof n.style == "string" && (a = n.style);
      const l = jt(o);
      if (!qe.has(l)) {
        const c = te("registerStyles", o.$tagName$);
        vs(l, a, !!(o.$flags$ & 1)), c();
      }
    }
  }
  const i = t.$ancestorComponent$, r = () => Nt(t, !0);
  i && i["s-rc"] ? i["s-rc"].push(r) : r();
}, ri = (e, t) => {
}, ai = (e) => {
  if (!(A.$flags$ & 1)) {
    const t = ee(e);
    if (!t)
      return;
    const o = t.$cmpMeta$, s = te("connectedCallback", o.$tagName$);
    if (t.$flags$ & 1)
      Cs(e, t, o.$listeners$), t != null && t.$lazyInstance$ || t != null && t.$onReadyPromise$ && t.$onReadyPromise$.then(() => ri());
    else {
      t.$flags$ |= 1;
      let n;
      if (n = e.getAttribute(ke), n) {
        if (o.$flags$ & 1) {
          const i = xs(e.shadowRoot, o);
          e.classList.remove(i + "-h", i + "-s");
        }
        qn(e, o.$tagName$, n, t);
      }
      n || // TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
      o.$flags$ & 12 && ci(e);
      {
        let i = e;
        for (; i = i.parentNode || i.host; )
          if (i.nodeType === 1 && i.hasAttribute("s-id") && i["s-p"] || i["s-p"]) {
            Es(t, t.$ancestorComponent$ = i);
            break;
          }
      }
      o.$members$ && Object.entries(o.$members$).map(([i, [r]]) => {
        if (r & 31 && e.hasOwnProperty(i)) {
          const a = e[i];
          delete e[i], e[i] = a;
        }
      }), ue.initializeNextTick ? Ve(() => xo(e, t, o)) : xo(e, t, o);
    }
    s();
  }
}, ci = (e) => {
  if (!S.document)
    return;
  const t = e["s-cr"] = S.document.createComment(
    ""
  );
  t["s-cn"] = !0, V(e, t, e.firstChild);
}, li = async (e) => {
  if (!(A.$flags$ & 1)) {
    const t = ee(e);
    t != null && t.$rmListeners$ && (t.$rmListeners$.map((o) => o()), t.$rmListeners$ = void 0);
  }
  ce.has(e) && ce.delete(e), e.shadowRoot && ce.has(e.shadowRoot) && ce.delete(e.shadowRoot);
}, F = (e, t) => {
  const o = {
    $flags$: t[0],
    $tagName$: t[1]
  };
  o.$members$ = t[2], o.$listeners$ = t[3], o.$watchers$ = e.$watchers$, o.$attrsToReflect$ = [], Bn();
  const s = e.prototype.connectedCallback, n = e.prototype.disconnectedCallback;
  return Object.assign(e.prototype, {
    __hasHostListenerAttached: !1,
    __registerHost() {
      gn(this, o);
    },
    connectedCallback() {
      if (!this.__hasHostListenerAttached) {
        const i = ee(this);
        if (!i)
          return;
        Cs(this, i, o.$listeners$), this.__hasHostListenerAttached = !0;
      }
      ai(this), s && s.call(this);
    },
    disconnectedCallback() {
      li(this), n && n.call(this);
    },
    __attachShadow() {
      if (!this.shadowRoot)
        On.call(this, o);
      else if (this.shadowRoot.mode !== "open")
        throw new Error(
          `Unable to re-use existing shadow root for ${o.$tagName$}! Mode is set to ${this.shadowRoot.mode} but Stencil only supports open shadow roots.`
        );
    }
  }), e.is = o.$tagName$, ii(e, o);
}, Cs = (e, t, o, s) => {
  o && S.document && o.map(([n, i, r]) => {
    const a = e, l = di(t, r), c = mi(n);
    A.ael(a, i, l, c), (t.$rmListeners$ = t.$rmListeners$ || []).push(() => A.rel(a, i, l, c));
  });
}, di = (e, t) => (o) => {
  try {
    e.$hostElement$[t](o);
  } catch (s) {
    Ae(s, e.$hostElement$);
  }
}, mi = (e) => (e & 2) !== 0;
const ae = {
  elementDelimiter: "__",
  modifierDelimiter: "--",
  namespace: "",
  namespaceDelimiter: "-",
  strict: !0
};
function ui({ elementDelimiter: e, modifierDelimiter: t, namespace: o, namespaceDelimiter: s, strict: n }) {
  typeof e == "string" && (ae.elementDelimiter = e), typeof t == "string" && (ae.modifierDelimiter = t), (typeof o == "string" || Array.isArray(o)) && (ae.namespace = o), typeof s == "string" && (ae.namespaceDelimiter = s), ae.strict = n;
}
const fi = (e) => e.join("").split("").filter((t, o, s) => s.indexOf(t) === o), _o = (e, t) => t.some((o) => e.includes(o)), yo = (e, t, o) => {
  const s = `"${o.join('", "')}"`;
  return `The ${e} ("${t}") must not use the characters contained within the delimiters (${s}).`;
};
function hi(e, t = {}) {
  const { elementDelimiter: o, modifierDelimiter: s, namespace: n, namespaceDelimiter: i, strict: r } = {
    ...ae,
    ...t
  }, l = `${[].concat(n).filter(Boolean).reduce((d, u) => `${d}${u}${i}`, "")}${e}`, c = r ? [i, o, s] : [], m = r ? fi(c) : [];
  return function(u, f) {
    if (u == null)
      return l;
    const g = typeof u == "string" ? u : null;
    if (r && g != null && _o(g, m))
      throw new Error(yo("element", g, c));
    const b = g == null ? l : `${l}${o}${g}`, x = typeof u == "string" ? f : u;
    if (x == null)
      return b;
    const h = (y, E) => {
      if (E != null && E !== "") {
        if (r && _o(E, m))
          throw new Error(yo("modifier", E, c));
        return `${y} ${b}${s}${E}`;
      }
      return y;
    };
    return Array.isArray(x) ? x.reduce(h, b) : Object.keys(x).filter((y) => x[y]).reduce(h, b);
  };
}
ui({
  strict: !1
});
const wo = (e) => typeof e != "object" ? e : Object.keys(e).reduce((t, o) => {
  const s = e[o];
  if (!s)
    return t;
  if (s === !0)
    return [...t, o];
  if (typeof s == "object") {
    const n = Object.keys(s).map((i) => `${o}-${s[i]}@${i}`);
    return [...t, ...n];
  }
  return [...t, `${o}-${s}`];
}, []), Te = (e) => (t, o) => {
  const s = typeof t == "string" ? t : wo(t);
  return hi(e)(s, wo(o));
}, he = typeof window > "u" ? {} : window;
var Go, Wo;
let ko = !!((Go = he.cosmosConfig) != null && Go.disableWarnings) || !!((Wo = he.gravityConfig) != null && Wo.disableWarnings);
const Ss = {
  get disableWarnings() {
    return ko;
  },
  set disableWarnings(e) {
    ko = e;
  }
};
he.cosmosConfig = Ss;
he.gravityConfig = Ss;
var K = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, pi = typeof K == "object" && K && K.Object === Object && K, bi = typeof self == "object" && self && self.Object === Object && self, gi = pi || bi || Function("return this")(), $o = gi.Symbol, zo = $o ? $o.prototype : void 0;
zo && zo.toString;
var vi = typeof K == "object" && K && K.Object === Object && K, xi = typeof self == "object" && self && self.Object === Object && self, _i = vi || xi || Function("return this")(), Eo = _i.Symbol, Co = Eo ? Eo.prototype : void 0;
Co && Co.toString;
const Mt = () => typeof process < "u" && process.versions != null && process.versions.node != null, yi = (e) => {
  if (e) {
    if (typeof HTMLFormElement.prototype.requestSubmit == "function")
      return e.requestSubmit();
    if (!Mt()) {
      const t = he.document.createElement("button");
      t.type = "submit", t.style.display = "none", e.appendChild(t), t.click(), t.remove();
    }
  }
}, Et = /([a-zA-Z0-9-]+)@([a-zA-Z0-9-]+)/, As = (e) => typeof e == "string" && Et.test(e), Ts = (e) => (e.match(new RegExp(Et, "g")) || []).reduce((o, s) => {
  const n = s.match(Et);
  if (n) {
    const [, i, r] = n;
    o[r] = i;
  }
  return o;
}, {});
function So(e, t) {
  if (!e || typeof e.querySelector != "function")
    return !1;
  try {
    return e.querySelector(`:scope > [slot="${t}"]`) !== null;
  } catch {
    return e.querySelector(`[slot="${t}"]`) !== null;
  }
}
class W {
  constructor() {
    this.observers = /* @__PURE__ */ new Map(), this.isNodeEnv = Mt(), this.observer = this.isNodeEnv ? null : this.createObserver();
  }
  /**
   * Gets the singleton instance of SlotMutationService.
   *
   * @returns {SlotMutationService} The singleton instance of SlotMutationService.
   * @static
   */
  static getInstance() {
    return W.instance || (W.instance = new W()), W.instance;
  }
  /**
   * Starts observing the given element for mutations.
   *
   * @remarks
   * It is recommended to call this method in the `componentWillLoad` lifecycle method
   * of a Stencil component to ensure that the element is observed as soon as it is loaded.
   *
   * @param {HTMLElement} element - The element to observe.
   * @param {() => void} handleSlotChange - The callback to execute when a mutation is observed.
   * @returns {void}
   */
  observe(t, o) {
    var s;
    this.isNodeEnv || this.observers.has(t) || (this.observers.set(t, o), (s = this.observer) == null || s.observe(t, W.OBSERVER_OPTIONS), o.call(t));
  }
  /**
   * Stops observing the given element for mutations.
   *
   * @remarks
   * It is recommended to call this method in the `disconnectedCallback` lifecycle method
   * of a Stencil component to ensure that the element is no longer observed when it is removed from the DOM.
   *
   * @param {HTMLElement} element - The element to stop observing.
   * @returns {void}
   */
  unobserve(t) {
    var o;
    this.isNodeEnv || !this.observers.has(t) || (this.observers.delete(t), this.observers.size === 0 && ((o = this.observer) == null || o.disconnect()));
  }
  /**
   * Creates a MutationObserver instance.
   *
   * @returns {MutationObserver} The created MutationObserver instance.
   * @private
   */
  createObserver() {
    return new MutationObserver(this.handleMutations.bind(this));
  }
  /**
   * Handles observed mutations.
   *
   * @param {MutationRecord[]} mutations - The array of observed mutations.
   * @returns {void}
   * @private
   */
  handleMutations(t) {
    t.forEach((o) => {
      this.observers.forEach((s, n) => {
        n.contains(o.target) && s.call(n);
      });
    });
  }
}
W.instance = null;
W.OBSERVER_OPTIONS = {
  childList: !0,
  subtree: !0,
  characterData: !0
};
W.getInstance();
const He = /* @__PURE__ */ new WeakMap();
let je;
typeof MutationObserver < "u" && (je = new MutationObserver((e) => {
  e.forEach(function(t) {
    var o;
    t.type === "attributes" && ((o = He.get(t.target)) === null || o === void 0 || o.forEach((s) => {
      var n;
      return s((n = t.target.getAttribute("mode")) !== null && n !== void 0 ? n : "light");
    }));
  });
}));
function Rs(e, t) {
  const o = t.closest(e);
  if (o)
    return o;
  const s = t.getRootNode();
  return s === he.document || !(s instanceof ShadowRoot) ? null : Rs(e, s.host);
}
function wi(e, t) {
  var o;
  const s = Rs($i("cosmos-mode"), e.element);
  s && (t((o = s.getAttribute("mode")) !== null && o !== void 0 ? o : "light"), He.has(s) ? He.get(s).push(t) : (je == null || je.observe(s, { attributes: !0 }), He.set(s, [t])));
}
function tt({ instance: e, modeToAppearanceMap: t, callback: o }) {
  e.appearance ? o(e.appearance) : wi(e, (s) => {
    e.appearance || o(t[s]);
  });
}
const ki = "11.1.1", $i = (e) => `${e}-${ki.replace(/\./g, "-")}`, zi = (e) => /^-?\d+$/.test(e), Ei = (e) => typeof e == "boolean" ? e : typeof e == "string" && ["", "true", "false"].includes(e) ? e !== "false" : !1;
function Ci(e) {
  if (zi(e))
    return Number(e);
  if (typeof e == "string" || typeof e == "boolean")
    return Ei(e) ? 1 : void 0;
}
function Si(e) {
  return typeof e == "number" ? e === 1 : !1;
}
function Ao(e) {
  return typeof e == "number" ? e > 1 : !1;
}
const Ai = '@charset "UTF-8";:host{display:block}:host([clamp]){min-width:0}:host{--cosmos-font-family-text:Bull Text, Helvetica, sans-serif}@supports (font-variation-settings: normal){:host{--cosmos-font-family-text:Bull VF, Helvetica, sans-serif}}:host(:lang(ja)){--cosmos-font-family-text:Noto Sans JP, Helvetica, sans-serif}:host(:lang(ar)){--cosmos-font-family-text:Noto Kufi Arabic, Helvetica, sans-serif}:host(:lang(ko)){--cosmos-font-family-text:Noto Sans KR, Helvetica, sans-serif}:host(:lang(hi)){--cosmos-font-family-text:Noto Sans, Helvetica, sans-serif}:host(:lang(he)){--cosmos-font-family-text:Noto Sans Hebrew, Helvetica, sans-serif}:host(:lang(ka)){--cosmos-font-family-text:Noto Sans Georgian, Helvetica, sans-serif}:host(:lang(th)){--cosmos-font-family-text:Noto Sans Thai, Helvetica, sans-serif}:host(:lang(zh)){--cosmos-font-family-text:Microsoft YaHei, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}:host(:lang(zh-Hant)){--cosmos-font-family-text:Microsoft JhengHei, Geneva CY, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}@supports (font-variation-settings: normal){::slotted(strong),::slotted(b){font-variation-settings:"opsz" 12, "wght" 700}}.cosmos-text{--cosmos-font-weight-default-text-variable-regular:"opsz" 12, "wght" 400;--cosmos-font-weight-default-text-variable-medium:"opsz" 12, "wght" 500;--cosmos-font-weight-default-text-variable-bold:"opsz" 12, "wght" 700;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;color:var(--cosmos-text-color, #000F1E);font-family:var(--cosmos-text-font-family, var(--cosmos-font-family-text));font-style:var(--cosmos-text-font-style, inherit);font-variant-numeric:tabular-nums;font-variation-settings:var(--cosmos-font-weight-default-text-variable-regular);font-variation-settings:var(--cosmos-text-font-variation-settings, var(--cosmos-font-weight-default-text-variable-regular));font-weight:var(--cosmos-text-font-weight, 400);letter-spacing:var(--cosmos-text-letter-spacing, inherit);line-height:var(--cosmos-text-line-height, 1.5);margin:0;text-transform:var(--cosmos-text-text-transform, var(--cosmos-text-transform, inherit))}.cosmos-text--single-line-clamp{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cosmos-text--multi-line-clamp{-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:var(--cosmos-text-clamp-length);overflow:hidden;}.cosmos-text--size-xx-small{line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em;font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)))}@media (min-width: 380px){.cosmos-text--size-xx-small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-xx-small{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-x-small{line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em;font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)))}@media (min-width: 380px){.cosmos-text--size-x-small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-x-small{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-small{line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em;font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)))}@media (min-width: 380px){.cosmos-text--size-small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-small{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-medium{line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em;font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)))}@media (min-width: 380px){.cosmos-text--size-medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-large{line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em;font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)))}@media (min-width: 380px){.cosmos-text--size-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-x-large{line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em;font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)))}@media (min-width: 380px){.cosmos-text--size-x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-xx-small\\@small{line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em;font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-xx-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-xx-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-x-small\\@small{line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em;font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-x-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-x-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-small\\@small{line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em;font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-medium\\@small{line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em;font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-medium\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-medium\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-large\\@small{line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em;font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-x-large\\@small{line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em;font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-x-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-x-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-xx-small\\@medium{line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em;font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-xx-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-x-small\\@medium{line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em;font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-x-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-x-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-small\\@medium{line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em;font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-medium\\@medium{line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em;font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-medium\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-medium\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-large\\@medium{line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em;font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-x-large\\@medium{line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em;font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-x-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-x-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-xx-small\\@large{line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em;font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-xx-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-x-small\\@large{line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em;font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-x-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-x-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-small\\@large{line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em;font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-medium\\@large{line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em;font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-medium\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-medium\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-large\\@large{line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em;font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-x-large\\@large{line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em;font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-x-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-x-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-xx-small\\@x-large{line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em;font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-xx-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-x-small\\@x-large{line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em;font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-x-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-x-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-small\\@x-large{line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em;font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-medium\\@x-large{line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em;font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-medium\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-medium\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-large\\@x-large{line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em;font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-x-large\\@x-large{line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em;font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-x-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-x-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-xx-small\\@xx-large{line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em;font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-xx-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-x-small\\@xx-large{line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em;font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-x-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-x-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-small\\@xx-large{line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em;font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-medium\\@xx-large{line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em;font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-medium\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-medium\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-large\\@xx-large{line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em;font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-x-large\\@xx-large{line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em;font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)))}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-x-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-x-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--spacing-none{margin-bottom:0;padding-top:0}.cosmos-text--spacing-long-form-bottom{padding-top:0}.cosmos-text--spacing-long-form-top{margin-bottom:0}.cosmos-text--weight-medium{font-variation-settings:var(--cosmos-text-font-variation-settings, var(--cosmos-font-weight-default-text-variable-medium));font-weight:var(--cosmos-text-font-weight, 500)}.cosmos-text--weight-bold{font-variation-settings:var(--cosmos-text-font-variation-settings, var(--cosmos-font-weight-default-text-variable-bold));font-weight:var(--cosmos-text-font-weight, 700)}.cosmos-text--kind-normal.cosmos-text--appearance-light{color:var(--cosmos-text-color, #FFFFFF)}.cosmos-text--kind-subtle{color:var(--cosmos-text-color, rgba(0, 15, 30, 0.6))}.cosmos-text--kind-subtle.cosmos-text--appearance-light{color:var(--cosmos-text-color, rgba(255, 255, 255, 0.6))}', Ti = Te("cosmos-text"), Ri = /* @__PURE__ */ F(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.kind = "normal", this.size = "medium", this.spacing = "none", this.tag = "p", this.weight = "regular", this.computedAppearance = "dark";
  }
  handleAppearanceChange(t) {
    this.computedAppearance = t;
  }
  setNumericClampValue() {
    this.numericClampValue = Ci(this.clamp);
  }
  getSize() {
    return this.size && As(this.size) ? Ts(this.size) : this.size;
  }
  componentWillLoad() {
    tt({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    }), this.setNumericClampValue();
  }
  render() {
    var t;
    const o = (t = this.tag) !== null && t !== void 0 ? t : "p";
    return v(q, { key: "889c30e34d41d052cb544200c8191ec83acb73bc", style: Ao(this.numericClampValue) ? { "--cosmos-text-clamp-length": `${this.numericClampValue}` } : {} }, v(o, { key: "25ac6865a920300161a9c3e53141a5211aeb33ad", class: Ti({
      spacing: this.spacing,
      kind: this.kind,
      weight: this.weight,
      appearance: this.computedAppearance,
      size: this.getSize(),
      "single-line-clamp": Si(this.numericClampValue),
      "multi-line-clamp": Ao(this.numericClampValue)
    }), part: "base" }, v("slot", { key: "9765bc714c585bff1dc5004139d9b4b24b71bf47" })));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      clamp: ["setNumericClampValue"]
    };
  }
  static get style() {
    return Ai;
  }
}, [1, "cosmos-text-11-1-1", {
  appearance: [513],
  clamp: [520],
  kind: [513],
  size: [513],
  spacing: [513],
  tag: [513],
  weight: [513],
  computedAppearance: [32]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  clamp: ["setNumericClampValue"]
}]);
function Ls() {
  if (typeof customElements > "u")
    return;
  ["cosmos-text-11-1-1"].forEach((t) => {
    switch (t) {
      case "cosmos-text-11-1-1":
        customElements.get(t) || customElements.define(t, Ri);
        break;
    }
  });
}
const To = "success", Oe = "error", Ro = "loading", Li = ':host{display:block;height:100%}.cosmos-image{display:-ms-flexbox;display:flex;height:100%;isolation:isolate;min-height:inherit;overflow:hidden}.cosmos-image--radius-none{border-radius:var(--cosmos-image-border-radius, 0)}.cosmos-image--radius-small{border-radius:var(--cosmos-image-border-radius, 2px)}.cosmos-image--radius-medium{border-radius:var(--cosmos-image-border-radius, 6px)}.cosmos-image--radius-large{border-radius:var(--cosmos-image-border-radius, 8px)}.cosmos-image--radius-full{border-radius:var(--cosmos-image-border-radius, 9999px)}.cosmos-image--fallback.cosmos-image--appearance-light{background-color:rgba(0, 15, 30, 0.05)}.cosmos-image--fallback.cosmos-image--appearance-dark{background-color:rgba(255, 255, 255, 0.1)}.cosmos-image--image-state-loading,.cosmos-image--fit-contain{background-color:transparent}.cosmos-image__container{display:grid;grid-template-areas:"image";height:100%;width:100%}.cosmos-image--has-preview:not(.cosmos-image--has-image) .cosmos-image__container{display:-ms-flexbox;display:flex}.cosmos-image--fit-contain .cosmos-image__container{place-content:center}.cosmos-image__preview-container,.cosmos-image__image{grid-area:image;max-height:100%;min-height:0}.cosmos-image--fit-cover .cosmos-image__preview-container,.cosmos-image--fit-cover .cosmos-image__image{}@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none){.cosmos-image--fit-cover .cosmos-image__preview-container,.cosmos-image--fit-cover .cosmos-image__image{width:100%}}.cosmos-image--fit-contain.cosmos-image--radius-none .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-none .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 0)}.cosmos-image--fit-contain.cosmos-image--radius-small .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-small .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 2px)}.cosmos-image--fit-contain.cosmos-image--radius-medium .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-medium .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 6px)}.cosmos-image--fit-contain.cosmos-image--radius-large .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-large .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 8px)}.cosmos-image--fit-contain.cosmos-image--radius-full .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-full .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 9999px)}.cosmos-image__preview-image,.cosmos-image__image{-o-object-fit:cover;object-fit:cover}.cosmos-image__preview-container{display:-ms-flexbox;display:flex;overflow:hidden;position:relative}.cosmos-image--fit-cover .cosmos-image__preview-container{width:100%}.cosmos-image__preview-image{-webkit-filter:blur(5px);filter:blur(5px);height:calc(100% + 5px * 2);inset:0;position:absolute;-webkit-transform:translate(-5px, -5px);transform:translate(-5px, -5px);width:calc(100% + 5px * 2)}.cosmos-image__preview-dummy{max-width:100%}.cosmos-image--has-preview:not(.cosmos-image--has-image) .cosmos-image__preview-dummy{width:100%}.cosmos-image__image{max-width:100%;-webkit-transition:opacity 0.2s cubic-bezier(0, 0.32, 0.32, 1);transition:opacity 0.2s cubic-bezier(0, 0.32, 0.32, 1);z-index:1}.cosmos-image--image-state-loading .cosmos-image__image{opacity:0}.cosmos-image--image-state-success .cosmos-image__image{opacity:1;width:100%}.cosmos-image--fit-cover .cosmos-image__image{height:100%}', ie = Te("cosmos-image"), Ii = /* @__PURE__ */ F(class extends j {
  handleAppearanceChange(t) {
    this.computedAppearance = t;
  }
  handleImageChange(t, o) {
    t !== o && (this.imageState = Ro);
  }
  handleObserveResizeChange(t) {
    this.containerResizeObserver && (this.containerResizeObserver.unobserve(this.container), t && this.containerResizeObserver.observe(this.container));
  }
  handleContainerResize(t) {
    t.forEach((o) => {
      if (o.target === this.container) {
        const { height: s, width: n } = o.contentRect;
        this.resize.emit({
          height: s,
          width: n
        });
      }
    });
  }
  preloadImage() {
    if (typeof Image < "u") {
      const t = new Image();
      t.src = this.image, t.complete ? this.imageState = To : this.imageState = Ro;
    }
  }
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.resize = Wn(this, "resize"), this.fit = "cover", this.imageAlt = "", this.radius = "none", this.computedAppearance = "light", this.handleImageLoad = () => {
      this.imageState = To;
    }, this.handleImageError = () => {
      this.imageState = Oe;
    }, this.handlePreviewError = () => {
      this.previewState = Oe;
    }, this.shouldDisplayFallback = () => !(this.shouldDisplayImage() || this.shouldDisplayPreview()), this.shouldDisplayImage = () => !!this.image && this.imageState !== Oe, this.shouldDisplayPreview = () => !!this.imagePreview && this.previewState !== Oe, !Mt() && (this.containerResizeObserver = new ResizeObserver((t) => this.handleContainerResize(t)));
  }
  componentWillLoad() {
    tt({
      instance: this,
      modeToAppearanceMap: { dark: "dark", light: "light" },
      callback: this.handleAppearanceChange.bind(this)
    }), !this.srcset && this.image && this.preloadImage();
  }
  componentDidLoad() {
    this.observeResize && this.handleObserveResizeChange(this.observeResize);
  }
  render() {
    return v("div", { key: "ff73f3e297f42d841bf4d4fdd3bc52807cdd6156", class: ie({
      appearance: this.computedAppearance,
      fallback: this.shouldDisplayFallback(),
      fit: this.fit,
      "has-image": !!this.image,
      "has-preview": !!this.imagePreview,
      "image-state": this.imageState,
      radius: this.radius
    }), part: "base", ref: (t) => this.container = t }, !this.shouldDisplayFallback() && v("div", { key: "f617f0599dcdecabca5f1d946226cd6cb55bcc1b", class: ie("container") }, this.shouldDisplayPreview() && v("div", { key: "2938deacf4b9f628a627c5875b4885b96c613095", class: ie("preview-container") }, v("img", { key: "85a16caab638aad65788d607e57e9d1568c9a5f4", alt: "", class: ie("preview-image"), onError: this.handlePreviewError, src: this.imagePreview }), v("img", { key: "96a4ab3388bacad99df47ba00f97f72dcdf2f884", alt: "", class: ie("preview-dummy"), src: this.imagePreview })), this.shouldDisplayImage() && v("img", { key: "ea24401e1e918105a8511e8d381a33e346a7e090", alt: this.imageAlt, class: ie("image"), loading: this.loading, onError: this.handleImageError, onLoad: this.handleImageLoad, part: "image", sizes: this.sizes, src: this.image, srcSet: this.srcset })));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      image: ["handleImageChange"],
      observeResize: ["handleObserveResizeChange"]
    };
  }
  static get style() {
    return Li;
  }
}, [1, "cosmos-image-11-1-1", {
  appearance: [513],
  fit: [513],
  image: [513],
  imageAlt: [513, "image-alt"],
  imagePreview: [513, "image-preview"],
  loading: [513],
  observeResize: [516, "observe-resize"],
  radius: [513],
  sizes: [513],
  srcset: [513],
  computedAppearance: [32],
  imageState: [32],
  previewState: [32]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  image: ["handleImageChange"],
  observeResize: ["handleObserveResizeChange"]
}]);
function Oi() {
  if (typeof customElements > "u")
    return;
  ["cosmos-image-11-1-1"].forEach((t) => {
    switch (t) {
      case "cosmos-image-11-1-1":
        customElements.get(t) || customElements.define(t, Ii);
        break;
    }
  });
}
const Pi = () => Math.floor(Math.random() * 1e3), Di = ":host{display:block;height:1em;width:1em}.cosmos-spinner{color:var(--cosmos-spinner-color, #000F1E);display:block;height:100%;width:100%}@media screen and (prefers-reduced-motion: no-preference){.cosmos-spinner{-webkit-animation:spin 0.7s linear infinite;animation:spin 0.7s linear infinite}@-webkit-keyframes spin{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}}.cosmos-spinner *{stop-color:currentColor}.cosmos-spinner--appearance-light{color:var(--cosmos-spinner-color, #FFFFFF)}", Hi = Te("cosmos-spinner"), ji = /* @__PURE__ */ F(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.computedAppearance = "dark";
  }
  handleAppearanceChange(t) {
    this.computedAppearance = t;
  }
  componentWillLoad() {
    tt({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    });
  }
  render() {
    const t = Pi();
    return v("svg", { key: "c5a3c4cc3a00d7b326fac67636ae5f83d14a4044", class: Hi({
      appearance: this.computedAppearance
    }), viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, v("path", { key: "0ef7f925f9763382168b488f506c9058dc277267", d: "M16.6292 7.75012C17.1997 8.73827 17.5 9.85919 17.5 11.0002C17.5 12.1412 17.1997 13.2621 16.6292 14.2503", stroke: `url(#segment-1-${t})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), v("path", { key: "e8711272c9cc6053c741f3baa9bd184e6486e8fe", d: "M16.6291 14.2502C16.0586 15.2384 15.2381 16.0589 14.25 16.6294C13.2619 17.1999 12.141 17.5003 11 17.5003", stroke: `url(#segment-2-${t})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), v("path", { key: "5ae82f4784d3f9724e61fbf1fe82d85a864aecd4", d: "M11 17.5003C9.859 17.5003 8.73812 17.1999 7.75 16.6294C6.76188 16.0589 5.94134 15.2384 5.37085 14.2502", stroke: `url(#segment-3-${t})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), v("path", { key: "9a780ef2a4dc204fcb1ff7e31abacc9816f22d4f", d: "M5.37086 14.2503C4.80035 13.2621 4.5 12.1412 4.5 11.0002C4.5 9.85919 4.80035 8.73827 5.37086 7.75012", stroke: `url(#segment-4-${t})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), v("path", { key: "de0f65592a6117fec561bc67693f8bb64e5c0312", d: "M5.37085 7.75008C5.94134 6.76196 6.76188 5.94141 7.75 5.3709C8.73812 4.80039 9.859 4.50003 11 4.5", stroke: `url(#segment-5-${t})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), v("defs", { key: "1da720a02bf31a57578480556796da4dc5822b6e" }, v("linearGradient", { key: "747d600e179c01dc93fe3d27d34b19e5c4b53e98", id: `segment-1-${t}`, x1: "15.5", y1: "8.5", x2: "15.5", y2: "13.5", gradientUnits: "userSpaceOnUse" }, v("stop", { key: "50e9c2c01b6d320ae63335204bb37ea16955ec17", "stop-opacity": "0" }), v("stop", { key: "d0f531c2701a67ba9fbce2d49d85ec5d99d53d3e", offset: "1", "stop-opacity": "0.25" })), v("linearGradient", { key: "4719a84dcb0004f5cbafc1c8ffe49cf010fd1a98", id: `segment-2-${t}`, x1: "15.5", y1: "13.5", x2: "13.2074", y2: "17.3236", gradientUnits: "userSpaceOnUse" }, v("stop", { key: "aea35487cc88682df3bd74156ca9a8bc01da7eef", "stop-opacity": "0.25" }), v("stop", { key: "17878a025c4af317643cb5452916eb3af22a58ba", offset: "1", "stop-opacity": "0.5" })), v("linearGradient", { key: "736c1404381a8e48e9de6409269cd810a0d0c309", id: `segment-3-${t}`, x1: "11", y1: "16", x2: "9.0824", y2: "12.3929", gradientUnits: "userSpaceOnUse" }, v("stop", { key: "b3277767b8ab01aa0dedae281b11ee8e1231a7cf", "stop-opacity": "0.5" }), v("stop", { key: "46aff87a5710ec7efc6db9e230b2ad09debb61f2", offset: "1", "stop-opacity": "0.75" })), v("linearGradient", { key: "dc24a1afdf41dec3c82a75ae749ee6f3847553fd", id: `segment-4-${t}`, x1: "6.5", y1: "13.5", x2: "6.5", y2: "8.5", gradientUnits: "userSpaceOnUse" }, v("stop", { key: "015dd981136f095d6595a01caa3d08eb9d227a43", "stop-opacity": "0.75" }), v("stop", { key: "71aeba2857f1b82ab0cdb3497fee03b106c1508c", offset: "1" })), v("linearGradient", { key: "e64b510a45c8dabc0ce119e322ddf2c47699c9f1", id: `segment-5-${t}`, x1: "7", y1: "8", x2: "9.13409", y2: "4.76796", gradientUnits: "userSpaceOnUse" }, v("stop", { key: "f34d576d425c412ab76f36df22daeccf096d8a04" }), v("stop", { key: "3287f5906b264e687edfa1da840fee7d2a8d1725", offset: "1" }))));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"]
    };
  }
  static get style() {
    return Di;
  }
}, [1, "cosmos-spinner-11-1-1", {
  appearance: [513],
  computedAppearance: [32]
}, void 0, {
  appearance: ["handleAppearanceChange"]
}]);
function Fi() {
  if (typeof customElements > "u")
    return;
  ["cosmos-spinner-11-1-1"].forEach((t) => {
    switch (t) {
      case "cosmos-spinner-11-1-1":
        customElements.get(t) || customElements.define(t, ji);
        break;
    }
  });
}
const Bi = ':host{display:inline-block;line-height:0;max-width:100%}:host([width=content]){width:auto}:host([width=full]){width:100%}@media screen and (min-width: 0){:host([width~="content@small"]){width:auto}}@media screen and (min-width: 0){:host([width~="full@small"]){width:100%}}@media screen and (min-width: 650px){:host([width~="content@medium"]){width:auto}}@media screen and (min-width: 650px){:host([width~="full@medium"]){width:100%}}@media screen and (min-width: 1000px){:host([width~="content@large"]){width:auto}}@media screen and (min-width: 1000px){:host([width~="full@large"]){width:100%}}@media screen and (min-width: 1200px){:host([width~="content@x-large"]){width:auto}}@media screen and (min-width: 1200px){:host([width~="full@x-large"]){width:100%}}@media screen and (min-width: 1350px){:host([width~="content@xx-large"]){width:auto}}@media screen and (min-width: 1350px){:host([width~="full@xx-large"]){width:100%}}.cosmos-button{--cosmos-icon-color:currentColor;--focus-offset:var(--cosmos-button-border-width, 1px);-ms-flex-align:center;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-color:var(--cosmos-button-border-color, transparent);border-radius:var(--cosmos-button-border-radius, 6px);border-style:solid;border-width:var(--cosmos-button-border-width, 1px);-webkit-box-sizing:border-box;box-sizing:border-box;cursor:pointer;display:-ms-flexbox;display:flex;height:var(--cosmos-button-height);-ms-flex-pack:center;justify-content:center;max-width:100%;outline:none;padding-block:0;position:relative;text-decoration:none;white-space:nowrap}.cosmos-button:focus,.cosmos-button:focus:not(:focus-visible){outline:none}.cosmos-button:focus:not(:focus-visible)::before{content:none}.cosmos-button:focus::before{border-radius:calc(var(--focus-radius, 6px) * 1.5);bottom:calc((4px + var(--focus-offset, 0px)) * -1);-webkit-box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + var(--focus-offset, 0px)) * -1);position:absolute;right:calc((4px + var(--focus-offset, 0px)) * -1);top:calc((4px + var(--focus-offset, 0px)) * -1);content:""}.cosmos-button.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover);border-color:var(--cosmos-button-border-color-hover, transparent)}.cosmos-button--busy:not(.cosmos-button--has-icon) .cosmos-button__spinner{left:50%;position:absolute;top:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.cosmos-button--busy:not(.cosmos-button--has-icon) .cosmos-button__label{visibility:hidden}.cosmos-button--busy.cosmos-button--has-icon ::slotted([slot=icon]){display:none}.cosmos-button__label{-ms-flex-item-align:baseline;align-self:baseline;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;--cosmos-text-color:currentColor;--cosmos-text-font-family:var(--cosmos-button-font-family);--cosmos-text-font-size:var(--cosmos-button-font-size);--cosmos-text-font-style:var(--cosmos-button-font-style);--cosmos-text-font-weight:var(--cosmos-button-font-weight);--cosmos-text-letter-spacing:var(--cosmos-button-letter-spacing);--cosmos-text-line-height:var(--cosmos-button-line-height);--cosmos-text-text-transform:var(--cosmos-button-text-transform)}:not(.cosmos-button--kind-link).cosmos-button--size-small .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(36rem / var(--cosmos-base-font-size, 16)));-webkit-margin-before:calc(var(--cosmos-button-border-width, 1px) * -1);margin-block-start:calc(var(--cosmos-button-border-width, 1px) * -1)}.cosmos-button--kind-link.cosmos-button--shape-circle.cosmos-button--size-small .cosmos-button__label,.cosmos-button--kind-link.cosmos-button--shape-square.cosmos-button--size-small .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(36rem / var(--cosmos-base-font-size, 16)))}:not(.cosmos-button--kind-link).cosmos-button--size-medium .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(40rem / var(--cosmos-base-font-size, 16)));-webkit-margin-before:calc(var(--cosmos-button-border-width, 1px) * -1);margin-block-start:calc(var(--cosmos-button-border-width, 1px) * -1)}.cosmos-button--kind-link.cosmos-button--shape-circle.cosmos-button--size-medium .cosmos-button__label,.cosmos-button--kind-link.cosmos-button--shape-square.cosmos-button--size-medium .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(40rem / var(--cosmos-base-font-size, 16)))}:not(.cosmos-button--kind-link).cosmos-button--size-large .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(48rem / var(--cosmos-base-font-size, 16)));-webkit-margin-before:calc(var(--cosmos-button-border-width, 1px) * -1);margin-block-start:calc(var(--cosmos-button-border-width, 1px) * -1)}.cosmos-button--kind-link.cosmos-button--shape-circle.cosmos-button--size-large .cosmos-button__label,.cosmos-button--kind-link.cosmos-button--shape-square.cosmos-button--size-large .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(48rem / var(--cosmos-base-font-size, 16)))}.cosmos-button__spinner{--cosmos-spinner-color:currentColor;height:calc(18rem / var(--cosmos-base-font-size, 16));width:calc(18rem / var(--cosmos-base-font-size, 16))}.cosmos-button ::slotted([slot=icon]),.cosmos-button__spinner{-ms-flex-negative:0;flex-shrink:0}.cosmos-button--icon-after{-ms-flex-direction:row-reverse;flex-direction:row-reverse}.cosmos-button--width-content{width:auto}.cosmos-button--width-full{width:100%}@media screen and (min-width: 0){.cosmos-button--width-content\\@small{width:auto}}@media screen and (min-width: 0){.cosmos-button--width-full\\@small{width:100%}}@media screen and (min-width: 650px){.cosmos-button--width-content\\@medium{width:auto}}@media screen and (min-width: 650px){.cosmos-button--width-full\\@medium{width:100%}}@media screen and (min-width: 1000px){.cosmos-button--width-content\\@large{width:auto}}@media screen and (min-width: 1000px){.cosmos-button--width-full\\@large{width:100%}}@media screen and (min-width: 1200px){.cosmos-button--width-content\\@x-large{width:auto}}@media screen and (min-width: 1200px){.cosmos-button--width-full\\@x-large{width:100%}}@media screen and (min-width: 1350px){.cosmos-button--width-content\\@xx-large{width:auto}}@media screen and (min-width: 1350px){.cosmos-button--width-full\\@xx-large{width:100%}}.cosmos-button--size-small{--cosmos-icon-size:var(--cosmos-button-icon-size, calc(16rem / var(--cosmos-base-font-size, 16)));--cosmos-button-height:calc(36rem / var(--cosmos-base-font-size, 16));gap:calc(4rem / var(--cosmos-base-font-size, 16));padding-inline:calc(16rem / var(--cosmos-base-font-size, 16))}.cosmos-button--size-medium{--cosmos-button-height:calc(40rem / var(--cosmos-base-font-size, 16));padding-inline:calc(20rem / var(--cosmos-base-font-size, 16))}.cosmos-button--size-large{--cosmos-button-height:calc(48rem / var(--cosmos-base-font-size, 16));padding-inline:calc(32rem / var(--cosmos-base-font-size, 16))}.cosmos-button--size-medium,.cosmos-button--size-large{--cosmos-icon-size:var(--cosmos-button-icon-size, calc(18rem / var(--cosmos-base-font-size, 16)));gap:calc(6rem / var(--cosmos-base-font-size, 16))}.cosmos-button--shape-pill:not(.cosmos-button--kind-link){--focus-radius:var(--cosmos-button-border-radius, 9999px);border-radius:var(--cosmos-button-border-radius, 9999px)}.cosmos-button--shape-square,.cosmos-button--shape-circle{gap:0;padding:0;width:var(--cosmos-button-height)}.cosmos-button--shape-square .cosmos-button__label,.cosmos-button--shape-circle .cosmos-button__label{-ms-flex-item-align:center;align-self:center}.cosmos-button--shape-square.cosmos-button--busy .cosmos-button__label,.cosmos-button--shape-circle.cosmos-button--busy .cosmos-button__label{display:none}.cosmos-button--shape-circle{--focus-radius:var(--cosmos-button-border-radius, 9999px);border-radius:var(--cosmos-button-border-radius, 9999px)}.cosmos-button--kind-primary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-primary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, #C3093B)}.cosmos-button--kind-secondary.cosmos-button--appearance-dark{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.1))}.cosmos-button--kind-secondary.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-secondary.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.2))}.cosmos-button--kind-secondary.cosmos-button--appearance-light{background:var(--cosmos-button-background, rgba(255, 255, 255, 0.1))}.cosmos-button--kind-secondary.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-secondary.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(255, 255, 255, 0.2))}.cosmos-button--kind-tertiary.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-tertiary.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.1));border-color:var(--cosmos-button-border-color-hover, rgba(0, 15, 30, 0.2))}.cosmos-button--kind-tertiary.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-tertiary.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(255, 255, 255, 0.1));border-color:var(--cosmos-button-border-color-hover, rgba(255, 255, 255, 0.2))}.cosmos-button--kind-bare.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-bare.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.1))}.cosmos-button--kind-bare.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-bare.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(255, 255, 255, 0.1))}.cosmos-button--kind-link{border-radius:var(--cosmos-button-border-radius, 0);border-width:0}.cosmos-button--kind-link:not(.cosmos-button--shape-circle,.cosmos-button--shape-square){height:auto;padding:0}.cosmos-button--kind-link.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-link:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){border-width:0 0 var(--cosmos-button-border-width, 2px) 0;margin-bottom:calc(var(--cosmos-button-border-width, 2px) * -1)}.cosmos-button--kind-link.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-link.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){border-color:var(--cosmos-button-border-color-hover, var(--cosmos-button-border-color, rgba(0, 15, 30, 0.2)))}.cosmos-button--kind-link.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-link.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){border-color:var(--cosmos-button-border-color-hover, var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2)))}.cosmos-button--kind-secondary,.cosmos-button--kind-cover-up{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}.cosmos-button--kind-tertiary,.cosmos-button--kind-bare,.cosmos-button--kind-link{background:var(--cosmos-button-background, transparent)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up{color:var(--cosmos-button-color, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){color:var(--cosmos-button-color-hover, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--appearance-dark{color:var(--cosmos-button-color, #000F1E)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--appearance-light{color:var(--cosmos-button-color, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark{color:var(--cosmos-button-color-hover, #000F1E)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light{color:var(--cosmos-button-color-hover, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary{background:var(--cosmos-button-background, #DB0A40)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-dark{border-color:var(--cosmos-button-border-color, rgba(0, 15, 30, 0.2))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-light{border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:focus.cosmos-button--appearance-dark{border-color:var(--cosmos-button-border-color, rgba(0, 15, 30, 0.1))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:focus.cosmos-button--appearance-light{border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.1))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.6));border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.8));border-color:var(--cosmos-button-border-color-hover, rgba(255, 255, 255, 0.45))}.cosmos-button--disabled{cursor:not-allowed}.cosmos-button--disabled.cosmos-button--kind-primary{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}.cosmos-button--disabled.cosmos-button--kind-primary.cosmos-button--appearance-dark{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.1))}.cosmos-button--disabled.cosmos-button--kind-primary.cosmos-button--appearance-light{background:var(--cosmos-button-background, rgba(255, 255, 255, 0.1))}.cosmos-button--disabled.cosmos-button--kind-tertiary.cosmos-button--appearance-dark{border-color:var(--cosmos-button-border-color, rgba(0, 15, 30, 0.1))}.cosmos-button--disabled.cosmos-button--kind-tertiary.cosmos-button--appearance-light{border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.1))}.cosmos-button--disabled.cosmos-button--kind-cover-up{color:var(--cosmos-button-color, rgba(255, 255, 255, 0.45))}.cosmos-button--disabled.cosmos-button--kind-cover-up.cosmos-button--appearance-light{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.45));border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2))}.cosmos-button--disabled.cosmos-button--kind-cover-up.cosmos-button--appearance-dark{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.45))}.cosmos-button--disabled.cosmos-button--appearance-dark:not(.cosmos-button--kind-cover-up){color:var(--cosmos-button-color, rgba(0, 15, 30, 0.45))}.cosmos-button--disabled.cosmos-button--appearance-light:not(.cosmos-button--kind-cover-up){color:var(--cosmos-button-color, rgba(255, 255, 255, 0.45))}', Ui = /* @__PURE__ */ F(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.busy = !1, this.decorative = !1, this.disabled = !1, this.hovered = !1, this.href = void 0, this.iconPlacement = "before", this.kind = "primary", this.size = "medium", this.type = "button", this.width = "content", this.computedAppearance = "dark", this.hasIconSlot = !1, this.handleIconSlotChange = () => {
      this.hasIconSlot = So(this.element, "icon");
    };
  }
  handleAppearanceChange(t) {
    this.computedAppearance = t;
  }
  /**
   * Removes focus from the Button.
   */
  async buttonBlur() {
    this.buttonElement && this.buttonElement.blur();
  }
  /**
   * Sets focus on the Button.
   */
  async buttonFocus() {
    this.buttonElement && this.buttonElement.focus();
  }
  handleClick(t) {
    const o = this.element.closest("form");
    if (this.disabled || this.busy) {
      t.stopImmediatePropagation(), t.preventDefault(), t.stopPropagation();
      return;
    }
    if (!(!this.isButton() || this.type === "button" || !o)) {
      if (this.type === "reset")
        return o.reset();
      if (this.type === "submit")
        return yi(o);
    }
  }
  getTextWeight() {
    return "medium";
  }
  getTextSize() {
    return this.size === "small" ? "x-small" : "small";
  }
  getType() {
    return this.isButton() ? this.type : void 0;
  }
  getWidth() {
    return this.width && As(this.width) ? Ts(this.width) : this.width;
  }
  getHostRole() {
    return this.ariaExpanded || this.ariaHaspopup || this.ariaLabel ? "presentation" : null;
  }
  isButton() {
    return !this.href && !this.decorative;
  }
  isLink() {
    return !!this.href && !this.decorative;
  }
  determineTag() {
    return this.isButton() ? "button" : this.isLink() ? "a" : "div";
  }
  getButtonAriaLabel() {
    var t;
    return this.buttonAriaLabel !== void 0 ? this.buttonAriaLabel : this.ariaLabel !== void 0 ? this.ariaLabel : this.buttonTitle ? this.buttonTitle : ((t = this.element.textContent) === null || t === void 0 ? void 0 : t.trim()) || "";
  }
  componentWillLoad() {
    this.hasIconSlot = So(this.element, "icon"), tt({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    });
  }
  render() {
    const t = this.determineTag(), o = Te("cosmos-button");
    return v(q, { key: "3792432c4187d9eb6035ec88de74000290487cd2", role: this.getHostRole() }, v(t, { key: "fbd69c81eef942d3663ca22ce43888a1ba71ed25", class: o({
      kind: this.kind,
      busy: this.busy,
      disabled: this.disabled || this.busy,
      appearance: this.computedAppearance,
      shape: this.shape || "pill",
      size: this.size,
      icon: this.iconPlacement,
      hovered: this.hovered,
      width: this.getWidth(),
      "has-icon": this.hasIconSlot
    }), disabled: this.disabled || this.busy, href: this.href, target: this.target, rel: this.rel, ref: (s) => this.buttonElement = s, type: this.getType(), part: "base", "aria-expanded": this.ariaExpanded, "aria-haspopup": this.ariaHaspopup, "aria-label": this.getButtonAriaLabel(), title: this.buttonTitle }, this.busy && v("cosmos-spinner-11-1-1", { key: "8ac68dc840afcbb57e89b09e8929661b461c1ae2", class: o("spinner") }), v("slot", { key: "85ba5c0d2f002182999ce5b3fe3bd30150e7d29b", name: "icon", onSlotchange: this.handleIconSlotChange }), v("cosmos-text-11-1-1", { key: "064652b95542f8e200da05ca683a286f1fb11629", class: o("label"), size: this.getTextSize(), tag: "span", weight: this.getTextWeight(), exportparts: "base: label" }, v("span", { key: "cbb4b064e2c1cf7bd75b380fe9b197832f3129d8" }, v("slot", { key: "2b13fe11cc9958dd177874d2a99540dc3f2c284a" })))));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"]
    };
  }
  static get style() {
    return Bi;
  }
}, [1, "cosmos-button-11-1-1", {
  appearance: [513],
  ariaExpanded: [513, "aria-expanded"],
  ariaHaspopup: [513, "aria-haspopup"],
  ariaLabel: [513, "aria-label"],
  busy: [516],
  buttonAriaLabel: [513, "button-aria-label"],
  buttonTitle: [513, "button-title"],
  decorative: [516],
  disabled: [516],
  hovered: [516],
  href: [513],
  iconPlacement: [513, "icon-placement"],
  kind: [513],
  rel: [513],
  shape: [513],
  size: [513],
  target: [513],
  type: [513],
  width: [513],
  computedAppearance: [32],
  hasIconSlot: [32],
  buttonBlur: [64],
  buttonFocus: [64]
}, [[2, "click", "handleClick"]], {
  appearance: ["handleAppearanceChange"]
}]);
function Ni() {
  if (typeof customElements > "u")
    return;
  ["cosmos-button-11-1-1", "cosmos-spinner-11-1-1", "cosmos-text-11-1-1"].forEach((t) => {
    switch (t) {
      case "cosmos-button-11-1-1":
        customElements.get(t) || customElements.define(t, Ui);
        break;
      case "cosmos-spinner-11-1-1":
        customElements.get(t) || Fi();
        break;
      case "cosmos-text-11-1-1":
        customElements.get(t) || Ls();
        break;
    }
  });
}
const Mi = Ni, qi = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", Gi = /* @__PURE__ */ F(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow();
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return v(q, { key: "fd71fc2fdd6eea638623d3ad6d8de8654d51fc70", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, v("svg", { key: "d8388172ac83f13fea860ea140d9f7976b07210e", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, v("path", { key: "448dbff25b6332b3d1d1bf2ae6f48384e2eaaf27", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m6.56 11.09 5.83 5.82a.5.5 0 0 0 .71 0l.35-.35a.51.51 0 0 0 0-.71l-5.12-5.12 5.12-5.11a.51.51 0 0 0 0-.71l-.35-.35a.5.5 0 0 0-.71 0l-5.83 5.82a.51.51 0 0 0 0 .71", fill: "currentColor" })));
  }
  static get style() {
    return qi;
  }
}, [1, "cosmos-icon-chevron-left-11-1-1", {
  ariaLabel: [513, "aria-label"]
}]);
function Wi() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-chevron-left-11-1-1"].forEach((t) => {
    switch (t) {
      case "cosmos-icon-chevron-left-11-1-1":
        customElements.get(t) || customElements.define(t, Gi);
        break;
    }
  });
}
const Yi = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", Xi = /* @__PURE__ */ F(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow();
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return v(q, { key: "d7e413c39ed23aa39c6e99b78c84ff15e742a86f", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, v("svg", { key: "150de7a504f15bf40920f8732d6f5d30dee11082", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, v("path", { key: "b7b63bfdb19a57ed4ee51610574517809cc2e5b6", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.45 10.38 9.62 4.56a.48.48 0 0 0-.7 0l-.36.35a.51.51 0 0 0 0 .71l5.12 5.12-5.12 5.11a.51.51 0 0 0 0 .71l.36.35a.48.48 0 0 0 .7 0l5.83-5.82a.51.51 0 0 0 0-.71", fill: "currentColor" })));
  }
  static get style() {
    return Yi;
  }
}, [1, "cosmos-icon-chevron-right-11-1-1", {
  ariaLabel: [513, "aria-label"]
}]);
function Ji() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-chevron-right-11-1-1"].forEach((t) => {
    switch (t) {
      case "cosmos-icon-chevron-right-11-1-1":
        customElements.get(t) || customElements.define(t, Xi);
        break;
    }
  });
}
const Zi = /* @__PURE__ */ F(class extends j {
  constructor() {
    super(), this.__registerHost(), this.mode = "light";
  }
  render() {
    return v("slot", { key: "bc9b1dfc7ceac0ef9cb0d3ac720e4cf579a04c19" });
  }
  get element() {
    return this;
  }
}, [4, "cosmos-mode-11-1-1", {
  mode: [513]
}]);
function Qi() {
  if (typeof customElements > "u")
    return;
  ["cosmos-mode-11-1-1"].forEach((t) => {
    switch (t) {
      case "cosmos-mode-11-1-1":
        customElements.get(t) || customElements.define(t, Zi);
        break;
    }
  });
}
const Ki = Wi, Vi = Ji, er = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", tr = /* @__PURE__ */ F(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow();
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return v(q, { key: "bfb7d007a7f70f5a58060df7d1e56f094c72f4a2", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, v("svg", { key: "74927125e0ea788ae86857288353acc55d4f126c", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, v("path", { key: "ada2ed4ba201f4974dd2b32421a6dce913cd124d", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M20 11a9 9 0 1 0-10.406 8.89v-6.288H7.309V11h2.285V9.017c0-2.255 1.343-3.501 3.4-3.501.984 0 2.014.175 2.014.175v2.215h-1.135c-1.118 0-1.467.694-1.467 1.406V11h2.496l-.399 2.602h-2.097v6.289A9 9 0 0 0 20 11", fill: "currentColor" })));
  }
  static get style() {
    return er;
  }
}, [1, "cosmos-icon-facebook-11-1-1", {
  ariaLabel: [513, "aria-label"]
}]);
function or() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-facebook-11-1-1"].forEach((t) => {
    switch (t) {
      case "cosmos-icon-facebook-11-1-1":
        customElements.get(t) || customElements.define(t, tr);
        break;
    }
  });
}
const sr = or, nr = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", ir = /* @__PURE__ */ F(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow();
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return v(q, { key: "1df2bbc9345dfcb34cb8e85df778ea9deb848d08", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, v("svg", { key: "00b25d456abb4990e15f2fe0dfb6c1b8be7049f9", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, v("path", { key: "bd38fccafd2d760a37200db34130317efeccb04b", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.973 3H7.666a5.8 5.8 0 0 0-1.948.364 4.15 4.15 0 0 0-2.354 2.354A5.8 5.8 0 0 0 3 7.666v6.614c.01.665.132 1.324.364 1.948a4.15 4.15 0 0 0 2.354 2.355 5.8 5.8 0 0 0 1.948.364c.33 0 .572.007.87.017.477.016 1.095.036 2.437.036 2.183 0 2.451 0 3.307-.053a5.8 5.8 0 0 0 1.948-.364 4.15 4.15 0 0 0 2.355-2.355 5.8 5.8 0 0 0 .364-1.948c0-.33.007-.572.017-.87A65 65 0 0 0 19 10.973c0-2.183 0-2.45-.053-3.307a5.8 5.8 0 0 0-.364-1.948 4.15 4.15 0 0 0-2.355-2.354A5.8 5.8 0 0 0 14.28 3zm0 1.445c2.14 0 2.397 0 3.21.053a4.5 4.5 0 0 1 1.489.268 2.6 2.6 0 0 1 1.53 1.53c.188.485.29 1 .3 1.52v6.421a4.4 4.4 0 0 1-.268 1.488 2.6 2.6 0 0 1-1.53 1.53c-.486.189-1 .29-1.52.3H7.763a4.4 4.4 0 0 1-1.488-.267 2.6 2.6 0 0 1-1.53-1.53c-.189-.486-.29-1-.3-1.52 0-.327-.008-.56-.018-.848a60 60 0 0 1-.036-2.363c0-2.14 0-2.398.054-3.211a4.5 4.5 0 0 1 .267-1.488c.257-.72.817-1.29 1.53-1.562a4.4 4.4 0 0 1 1.52-.268c.327 0 .56-.008.848-.017a59 59 0 0 1 2.363-.036m-4.12 6.582a4.12 4.12 0 1 1 8.24 0 4.12 4.12 0 0 1-8.24 0m4.12 2.675a2.676 2.676 0 1 1 0-5.35 2.676 2.676 0 0 1 0 5.35m4.281-5.993a.963.963 0 1 0 0-1.927.963.963 0 0 0 0 1.927", fill: "currentColor" })));
  }
  static get style() {
    return nr;
  }
}, [1, "cosmos-icon-instagram-11-1-1", {
  ariaLabel: [513, "aria-label"]
}]);
function rr() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-instagram-11-1-1"].forEach((t) => {
    switch (t) {
      case "cosmos-icon-instagram-11-1-1":
        customElements.get(t) || customElements.define(t, ir);
        break;
    }
  });
}
const ar = rr, cr = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", lr = /* @__PURE__ */ F(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow();
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return v(q, { key: "81eb5cb5a167fd34f026697890d7f74f2ce5c5d6", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, v("svg", { key: "009766d2685a8e662ed91784dda622d4342564c5", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, v("path", { key: "11235cf9ae1524f1508cf756f8a5f0ed99018413", d: "M17.175 10.219a5.76 5.76 0 0 1-3.385-1.093v4.975a4.56 4.56 0 0 1-.8 2.579 4.5 4.5 0 0 1-2.112 1.658 4.44 4.44 0 0 1-2.672.148 4.5 4.5 0 0 1-2.28-1.415 4.56 4.56 0 0 1-.561-5.126 4.5 4.5 0 0 1 1.919-1.883 4.45 4.45 0 0 1 2.639-.445v2.503a2.04 2.04 0 0 0-1.27.011 2.06 2.06 0 0 0-1.02.761 2.09 2.09 0 0 0 .014 2.438 2.04 2.04 0 0 0 2.3.745 2.06 2.06 0 0 0 1.025-.755 2.1 2.1 0 0 0 .391-1.219V4.375h2.427q-.003.31.051.617a3.4 3.4 0 0 0 1.487 2.233c.548.366 1.19.561 1.847.561z", fill: "currentColor" })));
  }
  static get style() {
    return cr;
  }
}, [1, "cosmos-icon-tiktok-11-1-1", {
  ariaLabel: [513, "aria-label"]
}]);
function dr() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-tiktok-11-1-1"].forEach((t) => {
    switch (t) {
      case "cosmos-icon-tiktok-11-1-1":
        customElements.get(t) || customElements.define(t, lr);
        break;
    }
  });
}
const mr = dr, ur = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", fr = /* @__PURE__ */ F(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow();
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return v(q, { key: "e5e30dc4f6070a804645994291e8ef74910487e9", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, v("svg", { key: "a236687ef716c69bd8387ca3e05bbebef6f2a832", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, v("path", { key: "d067b9f2f75dcc05c9814a6631168b1aa1d99184", d: "M12.317 9.775 18.144 3h-1.38l-5.06 5.883L7.66 3H3l6.112 8.896L3 19h1.381l5.344-6.212L13.993 19h4.661zm-1.892 2.199-.62-.886L4.88 4.04H7l3.977 5.688.62.886 5.168 7.393h-2.121z", fill: "currentColor" })));
  }
  static get style() {
    return ur;
  }
}, [1, "cosmos-icon-x-11-1-1", {
  ariaLabel: [513, "aria-label"]
}]);
function hr() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-x-11-1-1"].forEach((t) => {
    switch (t) {
      case "cosmos-icon-x-11-1-1":
        customElements.get(t) || customElements.define(t, fr);
        break;
    }
  });
}
const pr = hr, br = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", gr = /* @__PURE__ */ F(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow();
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return v(q, { key: "f302ba70a64f83a61ef0330abcde684f5d545dd4", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, v("svg", { key: "97974ae0dbc674e82d846e2bfb53100cb7643c39", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, v("path", { key: "2be0c9347df928f476bbcd579bfc8c6e6ab0450a", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.14 6.9a2.14 2.14 0 0 0-1.5-1.51A50 50 0 0 0 11 5a50 50 0 0 0-6.64.36 2.14 2.14 0 0 0-1.5 1.54 22.7 22.7 0 0 0-.35 4.1 22.6 22.6 0 0 0 .35 4.11 2.12 2.12 0 0 0 1.5 1.51c2.202.273 4.42.4 6.64.38a50 50 0 0 0 6.64-.36 2.12 2.12 0 0 0 1.5-1.51c.243-1.363.36-2.746.35-4.13a22.7 22.7 0 0 0-.35-4.1m-9.88 6.64v-5L13.7 11z", fill: "currentColor" })));
  }
  static get style() {
    return br;
  }
}, [1, "cosmos-icon-youtube-11-1-1", {
  ariaLabel: [513, "aria-label"]
}]);
function vr() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-youtube-11-1-1"].forEach((t) => {
    switch (t) {
      case "cosmos-icon-youtube-11-1-1":
        customElements.get(t) || customElements.define(t, gr);
        break;
    }
  });
}
const xr = vr, _r = Oi, yr = "@-webkit-keyframes cosmos-link-dim-border{0%{-webkit-text-decoration-color:transparent;text-decoration-color:transparent}100%{-webkit-text-decoration-color:currentColor;text-decoration-color:currentColor}}@keyframes cosmos-link-dim-border{0%{-webkit-text-decoration-color:transparent;text-decoration-color:transparent}100%{-webkit-text-decoration-color:currentColor;text-decoration-color:currentColor}}.cosmos-link{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent;border:0;color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-variation-settings:inherit;font-weight:inherit;line-height:inherit;margin:0;outline:none;padding:0;color:inherit;font:inherit;font-variant-numeric:inherit;letter-spacing:inherit;position:relative;text-align:inherit;text-decoration:none}.cosmos-link:not(:focus):hover{-webkit-animation:none;animation:none;border-color:currentColor;-o-border-image:none;border-image:none}.cosmos-link:focus-visible{border-radius:0.2em;-webkit-box-shadow:0 0 0 2px #fff, inset 0 0 0 2px #1B6AEE;box-shadow:0 0 0 2px #fff, inset 0 0 0 2px #1B6AEE;margin:0 -2px;padding:0 2px;text-decoration:none}.cosmos-link--kind-underlined{text-decoration:underline;text-decoration-thickness:0.105em;text-transform:inherit;text-underline-offset:0.125em}.cosmos-link--kind-underlined:not(:focus){-webkit-animation:1s cosmos-link-dim-border steps(2, start) infinite paused;animation:1s cosmos-link-dim-border steps(2, start) infinite paused}", wr = Te("cosmos-link"), kr = /* @__PURE__ */ F(class extends j {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.kind = "underlined", this.handleKeyDown = (t) => {
      this.href || (t.key === "Enter" || t.key === " ") && (t.preventDefault(), t.target.click());
    };
  }
  render() {
    const t = this.href ? "a" : "span", o = t === "span" ? "button" : void 0;
    return v(t, { key: "a5f4647e9241c8fa76a9850b1afc10fd67c1aa3f", class: wr({
      kind: this.kind
    }), href: this.href, onKeyDown: this.handleKeyDown, part: "base", rel: this.rel, role: o, tabIndex: 0, target: this.target }, v("slot", { key: "778a1c9ce227d5fa7af4d3ea1bb9416a752c6fe6" }));
  }
  static get style() {
    return yr;
  }
}, [1, "cosmos-link-11-1-1", {
  href: [513],
  kind: [513],
  rel: [513],
  target: [513]
}]);
function $r() {
  if (typeof customElements > "u")
    return;
  ["cosmos-link-11-1-1"].forEach((t) => {
    switch (t) {
      case "cosmos-link-11-1-1":
        customElements.get(t) || customElements.define(t, kr);
        break;
    }
  });
}
const zr = $r, Er = Qi, Cr = Ls, Ct = /* @__PURE__ */ B({
  tagName: "cosmos-button-11-1-1",
  defaultProps: { busy: !1, decorative: !1, disabled: !1, hovered: !1, href: void 0, iconPlacement: "before", kind: "primary", size: "medium", type: "button", width: "content" },
  defineCustomElement: Mi
}), Sr = /* @__PURE__ */ B({
  tagName: "cosmos-icon-chevron-left-11-1-1",
  defaultProps: {},
  defineCustomElement: Ki
}), Ar = /* @__PURE__ */ B({
  tagName: "cosmos-icon-chevron-right-11-1-1",
  defaultProps: {},
  defineCustomElement: Vi
}), Tr = /* @__PURE__ */ B({
  tagName: "cosmos-icon-facebook-11-1-1",
  defaultProps: {},
  defineCustomElement: sr
}), Rr = /* @__PURE__ */ B({
  tagName: "cosmos-icon-instagram-11-1-1",
  defaultProps: {},
  defineCustomElement: ar
}), Lr = /* @__PURE__ */ B({
  tagName: "cosmos-icon-tiktok-11-1-1",
  defaultProps: {},
  defineCustomElement: mr
}), Ir = /* @__PURE__ */ B({
  tagName: "cosmos-icon-x-11-1-1",
  defaultProps: {},
  defineCustomElement: pr
}), Or = /* @__PURE__ */ B({
  tagName: "cosmos-icon-youtube-11-1-1",
  defaultProps: {},
  defineCustomElement: xr
}), Pr = /* @__PURE__ */ B({
  tagName: "cosmos-image-11-1-1",
  defaultProps: { fit: "cover", imageAlt: "", radius: "none" },
  defineCustomElement: _r
}), Ye = /* @__PURE__ */ B({
  tagName: "cosmos-link-11-1-1",
  defaultProps: { kind: "underlined" },
  defineCustomElement: zr
}), Dr = /* @__PURE__ */ B({
  tagName: "cosmos-mode-11-1-1",
  defaultProps: { mode: "light" },
  defineCustomElement: Er
}), ne = /* @__PURE__ */ B({
  tagName: "cosmos-text-11-1-1",
  defaultProps: { kind: "normal", size: "medium", spacing: "none", tag: "p", weight: "regular" },
  defineCustomElement: Cr
});
var Hr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function jr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Is = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function o() {
      for (var i = "", r = 0; r < arguments.length; r++) {
        var a = arguments[r];
        a && (i = n(i, s(a)));
      }
      return i;
    }
    function s(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return o.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var r = "";
      for (var a in i)
        t.call(i, a) && i[a] && (r = n(r, a));
      return r;
    }
    function n(i, r) {
      return r ? i ? i + " " + r : i + r : i;
    }
    e.exports ? (o.default = o, e.exports = o) : window.classNames = o;
  })();
})(Is);
var Fr = Is.exports;
const Lo = /* @__PURE__ */ jr(Fr);
function Io(e, t = 0.5) {
  const [o, s] = Se(!0);
  return U(() => {
    const n = {
      root: e == null ? void 0 : e.parentElement,
      rootMargin: "0px",
      threshold: t
    }, i = new IntersectionObserver((r) => {
      var a;
      s(!!((a = r[0]) != null && a.isIntersecting));
    }, n);
    return e && i.observe(e), () => i.disconnect();
  }, [e, t]), o;
}
const Br = "E.", Ur = "feed-cards-rail-panel_standard", Nr = "energyDrink";
var O;
let Xe = (O = class {
  constructor(t, o = []) {
    st(this, "viewedSlots", /* @__PURE__ */ new Set());
    this.dataLayer = t, this.config = o;
  }
  static getInstance(t, o) {
    return O.instance ?? (O.instance = new O(t, o)), O.instance;
  }
  static trackEvent(t, o) {
    const s = O.instance, n = s == null ? void 0 : s.dataLayer;
    if (n) {
      const i = [], r = s.getBaseTrackingData(t);
      o.forEach((a) => {
        const l = s.getTrackingItem(a);
        s.shouldTrackEvent(t, l.promotion_id) && i.push(l), s.memorizeViewedSlot(t, l.promotion_id);
      }), i.length >= 1 && (r.ecommerce.items = i, n.push(r));
    }
  }
  getBaseTrackingData(t) {
    var o;
    return {
      event: t,
      ecommerce: {
        promotion_module: Ur,
        promotion_position_available: ((o = O.instance) == null ? void 0 : o.config.length) ?? 0
      }
    };
  }
  getTrackingItem(t) {
    const o = O.resolveEventData(t);
    return {
      promotion_id: o.assetId,
      promotion_name: o.href,
      creative_name: Nr,
      creative_slot: `${Br}${t + 1}`
    };
  }
  static resolveEventData(t) {
    var s;
    const o = (s = O.instance) == null ? void 0 : s.config[t];
    return o ? {
      assetId: o.assetId,
      href: o.href
    } : {
      assetId: "",
      href: ""
    };
  }
  shouldTrackEvent(t, o) {
    var s;
    return t === "view_promotion" ? !((s = O.instance) != null && s.viewedSlots.has(o)) : !0;
  }
  memorizeViewedSlot(t, o) {
    var s;
    t === "view_promotion" && ((s = O.instance) == null || s.viewedSlots.add(o));
  }
  static destroy() {
    O.instance = null;
  }
}, st(O, "instance", null), O);
const Mr = "https://api.redbull.com/v1/graphql", qr = "rrn:gql-queries:f9635e8d-c78a-55e9-9330-4b704f5fd501", Gr = "0ifKR2VQssohYb83TXojJD5LSOy4NlBM";
async function Wr(e) {
  try {
    const t = await fetch(`${Mr}/${qr}?locale=${e}`, {
      headers: {
        "API-Key": Gr
      }
    });
    return t.ok ? await t.json() : void 0;
  } catch (t) {
    console.error("Error while loading graphQl data", t);
    return;
  }
}
function Yr(e) {
  const t = Math.min(window.devicePixelRatio, 2);
  return Math.floor(t * e);
}
function Xr(e) {
  return e >= 2 ? "auto:low" : "auto";
}
function Jr(e, t, o) {
  const s = Xr(o), i = `e_trim/c_limit,w_${Yr(t)}/q_${s},f_auto`;
  return e.replace("{op}", i);
}
const Zr = [
  { width: 200, devicePixelRatio: 1 },
  { width: 300, devicePixelRatio: 1 },
  { width: 400, devicePixelRatio: 2 },
  { width: 600, devicePixelRatio: 2 }
];
function Qr(e) {
  const t = Zr.map(({ width: o, devicePixelRatio: s }) => ({
    width: o,
    src: Jr(e, o, s)
  }));
  return {
    src: t[0].src,
    srcset: t.map((o) => `${o.src} ${o.width}w`).join(", ")
  };
}
function Kr(e) {
  var s;
  const t = document == null ? void 0 : document.documentElement;
  return t ? ((s = getComputedStyle(t)) == null ? void 0 : s.direction) === "rtl" : !1;
}
const Vr = (e) => {
  const t = window.location.hostname;
  return e.replace(`https://${t}/`, "/").replace(`http://${t}/`, "/");
}, ea = async (e) => {
  var s, n;
  const t = await Wr(e), o = (n = (s = t == null ? void 0 : t.data) == null ? void 0 : s.feed) == null ? void 0 : n.edges;
  if (o)
    return o.filter((i) => !!i).map((i) => i.node).filter((i) => !!i).map((i) => {
      var g, b, x, h, y;
      const r = (g = i.featuredImages) == null ? void 0 : g.find((E) => !!E), a = i.localBrandName, l = (b = i.title) == null ? void 0 : b.text, c = i.id, m = r == null ? void 0 : r.imageEssence.attributes.imageURL, d = (x = i.url) == null ? void 0 : x.href, u = (h = r == null ? void 0 : r.title) == null ? void 0 : h.text;
      if (!a || !l || !m || !d || !u)
        return;
      const f = (y = r.teaser) == null ? void 0 : y.text;
      return {
        title: a,
        subTitle: l,
        altText: f ?? u,
        imageUrl: m,
        href: d,
        assetId: c
      };
    }).filter((i) => !!i);
};
function ta(e, t) {
  for (var o in t) e[o] = t[o];
  return e;
}
function St(e, t) {
  for (var o in e) if (o !== "__source" && !(o in t)) return !0;
  for (var s in t) if (s !== "__source" && e[s] !== t[s]) return !0;
  return !1;
}
function Oo(e, t) {
  this.props = e, this.context = t;
}
function Os(e, t) {
  function o(n) {
    var i = this.props.ref, r = i == n.ref;
    return !r && i && (i.call ? i(null) : i.current = null), t ? !t(this.props, n) || !r : St(this.props, n);
  }
  function s(n) {
    return this.shouldComponentUpdate = o, M(e, n);
  }
  return s.displayName = "Memo(" + (e.displayName || e.name) + ")", s.prototype.isReactComponent = !0, s.__f = !0, s;
}
(Oo.prototype = new Y()).isPureReactComponent = !0, Oo.prototype.shouldComponentUpdate = function(e, t) {
  return St(this.props, e) || St(this.state, t);
};
var Po = w.__b;
w.__b = function(e) {
  e.type && e.type.__f && e.ref && (e.props.ref = e.ref, e.ref = null), Po && Po(e);
};
var oa = w.__e;
w.__e = function(e, t, o, s) {
  if (e.then) {
    for (var n, i = t; i = i.__; ) if ((n = i.__c) && n.__c) return t.__e == null && (t.__e = o.__e, t.__k = o.__k), n.__c(e, t);
  }
  oa(e, t, o, s);
};
var Do = w.unmount;
function Ps(e, t, o) {
  return e && (e.__c && e.__c.__H && (e.__c.__H.__.forEach(function(s) {
    typeof s.__c == "function" && s.__c();
  }), e.__c.__H = null), (e = ta({}, e)).__c != null && (e.__c.__P === o && (e.__c.__P = t), e.__c.__e = !0, e.__c = null), e.__k = e.__k && e.__k.map(function(s) {
    return Ps(s, t, o);
  })), e;
}
function Ds(e, t, o) {
  return e && o && (e.__v = null, e.__k = e.__k && e.__k.map(function(s) {
    return Ds(s, t, o);
  }), e.__c && e.__c.__P === t && (e.__e && o.appendChild(e.__e), e.__c.__e = !0, e.__c.__P = o)), e;
}
function at() {
  this.__u = 0, this.o = null, this.__b = null;
}
function Hs(e) {
  var t = e.__.__c;
  return t && t.__a && t.__a(e);
}
function Pe() {
  this.i = null, this.l = null;
}
w.unmount = function(e) {
  var t = e.__c;
  t && t.__R && t.__R(), t && 32 & e.__u && (e.type = null), Do && Do(e);
}, (at.prototype = new Y()).__c = function(e, t) {
  var o = t.__c, s = this;
  s.o == null && (s.o = []), s.o.push(o);
  var n = Hs(s.__v), i = !1, r = function() {
    i || (i = !0, o.__R = null, n ? n(a) : a());
  };
  o.__R = r;
  var a = function() {
    if (!--s.__u) {
      if (s.state.__a) {
        var l = s.state.__a;
        s.__v.__k[0] = Ds(l, l.__c.__P, l.__c.__O);
      }
      var c;
      for (s.setState({ __a: s.__b = null }); c = s.o.pop(); ) c.forceUpdate();
    }
  };
  s.__u++ || 32 & t.__u || s.setState({ __a: s.__b = s.__v.__k[0] }), e.then(r, r);
}, at.prototype.componentWillUnmount = function() {
  this.o = [];
}, at.prototype.render = function(e, t) {
  if (this.__b) {
    if (this.__v.__k) {
      var o = document.createElement("div"), s = this.__v.__k[0].__c;
      this.__v.__k[0] = Ps(this.__b, o, s.__O = s.__P);
    }
    this.__b = null;
  }
  var n = t.__a && M(H, null, e.fallback);
  return n && (n.__u &= -33), [M(H, null, t.__a ? null : e.children), n];
};
var Ho = function(e, t, o) {
  if (++o[1] === o[0] && e.l.delete(t), e.props.revealOrder && (e.props.revealOrder[0] !== "t" || !e.l.size)) for (o = e.i; o; ) {
    for (; o.length > 3; ) o.pop()();
    if (o[1] < o[0]) break;
    e.i = o = o[2];
  }
};
(Pe.prototype = new Y()).__a = function(e) {
  var t = this, o = Hs(t.__v), s = t.l.get(e);
  return s[0]++, function(n) {
    var i = function() {
      t.props.revealOrder ? (s.push(n), Ho(t, e, s)) : n();
    };
    o ? o(i) : i();
  };
}, Pe.prototype.render = function(e) {
  this.i = null, this.l = /* @__PURE__ */ new Map();
  var t = Ue(e.children);
  e.revealOrder && e.revealOrder[0] === "b" && t.reverse();
  for (var o = t.length; o--; ) this.l.set(t[o], this.i = [1, 0, this.i]);
  return e.children;
}, Pe.prototype.componentDidUpdate = Pe.prototype.componentDidMount = function() {
  var e = this;
  this.l.forEach(function(t, o) {
    Ho(e, o, t);
  });
};
var sa = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, na = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, ia = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, ra = /[A-Z0-9]/g, aa = typeof document < "u", ca = function(e) {
  return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/ : /fil|che|ra/).test(e);
};
Y.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(e) {
  Object.defineProperty(Y.prototype, e, { configurable: !0, get: function() {
    return this["UNSAFE_" + e];
  }, set: function(t) {
    Object.defineProperty(this, e, { configurable: !0, writable: !0, value: t });
  } });
});
var jo = w.event;
function la() {
}
function da() {
  return this.cancelBubble;
}
function ma() {
  return this.defaultPrevented;
}
w.event = function(e) {
  return jo && (e = jo(e)), e.persist = la, e.isPropagationStopped = da, e.isDefaultPrevented = ma, e.nativeEvent = e;
};
var ua = { enumerable: !1, configurable: !0, get: function() {
  return this.class;
} }, Fo = w.vnode;
w.vnode = function(e) {
  typeof e.type == "string" && function(t) {
    var o = t.props, s = t.type, n = {}, i = s.indexOf("-") === -1;
    for (var r in o) {
      var a = o[r];
      if (!(r === "value" && "defaultValue" in o && a == null || aa && r === "children" && s === "noscript" || r === "class" || r === "className")) {
        var l = r.toLowerCase();
        r === "defaultValue" && "value" in o && o.value == null ? r = "value" : r === "download" && a === !0 ? a = "" : l === "translate" && a === "no" ? a = !1 : l[0] === "o" && l[1] === "n" ? l === "ondoubleclick" ? r = "ondblclick" : l !== "onchange" || s !== "input" && s !== "textarea" || ca(o.type) ? l === "onfocus" ? r = "onfocusin" : l === "onblur" ? r = "onfocusout" : ia.test(r) && (r = l) : l = r = "oninput" : i && na.test(r) ? r = r.replace(ra, "-$&").toLowerCase() : a === null && (a = void 0), l === "oninput" && n[r = l] && (r = "oninputCapture"), n[r] = a;
      }
    }
    s == "select" && n.multiple && Array.isArray(n.value) && (n.value = Ue(o.children).forEach(function(c) {
      c.props.selected = n.value.indexOf(c.props.value) != -1;
    })), s == "select" && n.defaultValue != null && (n.value = Ue(o.children).forEach(function(c) {
      c.props.selected = n.multiple ? n.defaultValue.indexOf(c.props.value) != -1 : n.defaultValue == c.props.value;
    })), o.class && !o.className ? (n.class = o.class, Object.defineProperty(n, "className", ua)) : (o.className && !o.class || o.class && o.className) && (n.class = n.className = o.className), t.props = n;
  }(e), e.$$typeof = sa, Fo && Fo(e);
};
var Bo = w.__r;
w.__r = function(e) {
  Bo && Bo(e), e.__c;
};
var Uo = w.diffed;
w.diffed = function(e) {
  Uo && Uo(e);
  var t = e.props, o = e.__e;
  o != null && e.type === "textarea" && "value" in t && t.value !== o.value && (o.value = t.value == null ? "" : t.value);
};
const fa = '.energy-drink-feed-card{position:relative;display:block;z-index:0;border-radius:8px;box-shadow:0 8px 12px #000f1e0a,0 2px 4px #000f1e05;transform:translateZ(0)}.energy-drink-feed-card:focus,.energy-drink-feed-card:focus:not(:focus-visible){outline:none}.energy-drink-feed-card:focus:before{border-radius:12px;position:absolute;top:-4px;bottom:-4px;left:-4px;right:-4px;box-shadow:inset 0 0 0 2px #1b6aee,0 0 0 2px #fff;content:""}.energy-drink-feed-card:focus:not(:focus-visible):before{content:none}.energy-drink-feed-card:hover .energy-drink-feed-card__can{transition:transform .8s cubic-bezier(.35,0,0,1);transform:scale(1.05)}.energy-drink-feed-card .energy-drink-feed-card__can{transition:transform .6s cubic-bezier(.35,0,0,1)}.energy-drink-feed-card__wrapper{background:#fff;background-blend-mode:overlay;border-radius:8px;overflow:hidden;content-visibility:auto;padding-bottom:125%}@media (min-width: 650px){.energy-drink-feed-card__wrapper{padding-bottom:133.3333333333%}}.energy-drink-feed-card__content{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;flex-direction:column;justify-content:space-between}.energy-drink-feed-card__edition-wrapper{display:flex;flex-direction:column;color:#1a1919;white-space:pre-wrap;justify-content:center;text-wrap:balance;padding:24px 8px;text-align:center;flex-shrink:0;box-sizing:border-box;flex-basis:138px}.energy-drink-feed-card__edition-wrapper:lang(ko){word-break:keep-all}@media (min-width: 650px){.energy-drink-feed-card__edition-wrapper{flex-basis:143px}}@media (min-width: 1000px){.energy-drink-feed-card__edition-wrapper{flex-basis:147px}}.energy-drink-feed-card__cantainer{display:flex;margin:auto;height:100%;width:100%;min-height:0}.energy-drink-feed-card__can{width:100%;display:flex;justify-content:center;filter:drop-shadow(0 0 8px rgba(0,15,30,.02)) drop-shadow(0 20px 24px rgba(0,15,30,.16))}', ha = ".rail-image{height:100%}", pa = Os(({ altText: e, imageUrl: t }) => {
  const { src: o, srcset: s } = Qr(t);
  return /* @__PURE__ */ p(H, { children: [
    /* @__PURE__ */ p("style", { children: ha }),
    /* @__PURE__ */ p("img", { className: "rail-image", src: o, srcSet: s, sizes: "(max-width: 999px) 300px,(max-width: 1920px) 200px,300px", alt: e, "aria-hidden": !0 })
  ] });
}), ba = Os(({ title: e, subTitle: t, altText: o, imageUrl: s, href: n, slot: i }) => {
  const r = () => {
    Xe.trackEvent("select_promotion", [i]);
  };
  return /* @__PURE__ */ p(H, { children: [
    /* @__PURE__ */ p("style", { children: fa }),
    /* @__PURE__ */ p(
      "a",
      {
        class: "energy-drink-feed-card",
        href: Vr(n),
        tabindex: 0,
        onFocusIn: (a) => a.target.scrollIntoView(),
        onClick: r,
        children: /* @__PURE__ */ p("div", { className: "energy-drink-feed-card__wrapper", children: /* @__PURE__ */ p("div", { className: "energy-drink-feed-card__content", children: [
          /* @__PURE__ */ p("div", { className: "energy-drink-feed-card__edition-wrapper", children: [
            /* @__PURE__ */ p("div", { className: "energy-drink-feed-card__edition-line", children: /* @__PURE__ */ p(ne, { size: "x-large", weight: "bold", appearance: "dark", children: Ne(e) }) }),
            /* @__PURE__ */ p("div", { className: "energy-drink-feed-card__edition-line", children: /* @__PURE__ */ p(ne, { size: "x-large", weight: "bold", appearance: "dark", children: Ne(t) }) })
          ] }),
          /* @__PURE__ */ p("div", { className: "energy-drink-feed-card__cantainer", children: /* @__PURE__ */ p("div", { className: "energy-drink-feed-card__can", children: /* @__PURE__ */ p(pa, { altText: o, imageUrl: s }) }) })
        ] }) })
      }
    )
  ] });
}), ga = ".card-rail{--default-outerGap: 16px;position:relative;--numberOfElements: 1.1;--gap: 20px}@media (min-width: 650px){.card-rail{--default-outerGap: 40px;--numberOfElements: 2}}@media (min-width: 1000px){.card-rail{--default-outerGap: 32px;--numberOfElements: 4}}@media (min-width: 1200px){.card-rail{--numberOfElements: 5}}.card-rail__previous,.card-rail__next{position:absolute;z-index:1;top:calc(50% - 18px);transform:scaleX(-1)}@media (pointer: coarse){.card-rail__previous,.card-rail__next{display:none}}.card-rail__previous--hide,.card-rail__next--hide{display:none}.card-rail__previous{left:5px}.card-rail__next{right:5px}.card-rail__card-list{padding-top:16px;padding-bottom:16px;display:flex;gap:var(--gap);overflow:hidden;overflow-x:auto;scroll-snap-type:x mandatory;scroll-snap-stop:always;scroll-behavior:smooth;overscroll-behavior-inline:contain;-webkit-overflow-scrolling:touch;scrollbar-width:none}.card-rail__card-list::-webkit-scrollbar{display:none}.card-rail__card{box-sizing:content-box;--outerGap: var(--rb-energy-drink-rail-spacing, var(--default-outerGap));min-width:calc((100% - (var(--numberOfElements) + 3) * var(--gap)) / var(--numberOfElements));scroll-snap-align:center;scroll-margin-left:calc(2 * var(--gap));scroll-margin-right:calc(2 * var(--gap))}.card-rail__card:first-child{padding-inline-start:var(--outerGap)}.card-rail__card:last-child{padding-inline-end:var(--outerGap)}@media (min-width: 650px){.card-rail__card{scroll-snap-align:start}}", va = ({ configs: e }) => {
  const t = ut(null), o = ut([]), [s, n] = Se(!1), i = be(() => Kr(), []), r = Io(o.current[0]), a = Io(o.current[e.length - 1]);
  U(() => {
    const u = o.current.length === e.length && o.current.every((f) => f !== null);
    n(u);
  }, [e]);
  const l = _e(() => {
    if (!t.current)
      return;
    const u = [], f = t.current.getBoundingClientRect();
    o.current.forEach((g, b) => {
      if (g) {
        const x = g.getBoundingClientRect(), h = x.left + x.width / 2;
        h < f.right && h > f.left && u.push(b);
      }
    }), u.length > 0 && Xe.trackEvent("view_promotion", u);
  }, [t]);
  U(() => {
    const u = t.current;
    if (!u)
      return () => {
      };
    const f = () => {
      l();
    };
    return u.addEventListener("scrollend", f), () => {
      u.removeEventListener("scrollend", f);
    };
  }, [l]), U(() => {
    if (s && t.current) {
      const u = new IntersectionObserver(
        (f) => {
          const g = f.find((b) => b.target === t.current);
          g != null && g.isIntersecting && (l(), u.disconnect());
        },
        { threshold: 0.1 }
      );
      return u.observe(t.current), () => u.disconnect();
    }
    return () => {
    };
  }, [e, s, l]);
  const c = _e(
    (u) => {
      if (s && t.current) {
        const f = t.current.getBoundingClientRect().width;
        t.current.scrollBy({ left: u === "left" ? -f : f });
      }
    },
    [s, t]
  ), m = _e(
    (u) => {
      c(u === "left" ? i ? "right" : "left" : i ? "left" : "right");
    },
    [i, c]
  ), d = (u) => (f) => {
    o.current[u] = f;
  };
  return /* @__PURE__ */ p(H, { children: [
    /* @__PURE__ */ p("style", { children: ga }),
    /* @__PURE__ */ p("div", { class: "card-rail", tabindex: -1, children: [
      /* @__PURE__ */ p(
        Ct,
        {
          className: Lo("card-rail__previous", {
            "card-rail__previous--hide": r
          }),
          kind: "cover-up",
          shape: "circle",
          size: "small",
          onClick: () => m("left"),
          tabindex: -1,
          "aria-hidden": !0,
          children: /* @__PURE__ */ p(Ar, { slot: "icon" })
        }
      ),
      /* @__PURE__ */ p(
        Ct,
        {
          className: Lo("card-rail__next", {
            "card-rail__next--hide": a
          }),
          kind: "cover-up",
          shape: "circle",
          size: "small",
          onClick: () => m("right"),
          tabindex: -1,
          "aria-hidden": !0,
          children: /* @__PURE__ */ p(Sr, { slot: "icon" })
        }
      ),
      /* @__PURE__ */ p("div", { className: "card-rail__card-list", ref: t, tabindex: -1, children: e.map((u, f) => /* @__PURE__ */ p("div", { className: "card-rail__card", ref: d(f), children: /* @__PURE__ */ p(
        ba,
        {
          title: u.title,
          subTitle: u.subTitle,
          altText: u.altText,
          imageUrl: u.imageUrl,
          href: u.href,
          slot: f
        }
      ) }, f)) })
    ] })
  ] });
}, xa = ({
  customDataLayer: e,
  locale: t,
  skipCosmosFontInjection: o
}) => {
  const [s, n] = Se();
  return U(() => {
    t && (async () => {
      const r = await ea(t);
      n(r);
    })();
  }, [t]), U(() => (s != null && s.length && Xe.getInstance(e ?? window.dataLayer, s), () => {
    Xe.destroy();
  }), [e, s]), U(() => {
    Me(o) || Ot(It);
  }, [o]), s ? /* @__PURE__ */ p(va, { configs: s }) : null;
};
var js = { exports: {} };
(function(e) {
  (function(t, o) {
    e.exports ? e.exports = o() : t.log = o();
  })(Hr, function() {
    var t = function() {
    }, o = "undefined", s = typeof window !== o && typeof window.navigator !== o && /Trident\/|MSIE /.test(window.navigator.userAgent), n = [
      "trace",
      "debug",
      "info",
      "warn",
      "error"
    ], i = {}, r = null;
    function a(b, x) {
      var h = b[x];
      if (typeof h.bind == "function")
        return h.bind(b);
      try {
        return Function.prototype.bind.call(h, b);
      } catch {
        return function() {
          return Function.prototype.apply.apply(h, [b, arguments]);
        };
      }
    }
    function l() {
      console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
    }
    function c(b) {
      return b === "debug" && (b = "log"), typeof console === o ? !1 : b === "trace" && s ? l : console[b] !== void 0 ? a(console, b) : console.log !== void 0 ? a(console, "log") : t;
    }
    function m() {
      for (var b = this.getLevel(), x = 0; x < n.length; x++) {
        var h = n[x];
        this[h] = x < b ? t : this.methodFactory(h, b, this.name);
      }
      if (this.log = this.debug, typeof console === o && b < this.levels.SILENT)
        return "No console available for logging";
    }
    function d(b) {
      return function() {
        typeof console !== o && (m.call(this), this[b].apply(this, arguments));
      };
    }
    function u(b, x, h) {
      return c(b) || d.apply(this, arguments);
    }
    function f(b, x) {
      var h = this, y, E, k, L = "loglevel";
      typeof b == "string" ? L += ":" + b : typeof b == "symbol" && (L = void 0);
      function D(_) {
        var z = (n[_] || "silent").toUpperCase();
        if (!(typeof window === o || !L)) {
          try {
            window.localStorage[L] = z;
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(L) + "=" + z + ";";
          } catch {
          }
        }
      }
      function X() {
        var _;
        if (!(typeof window === o || !L)) {
          try {
            _ = window.localStorage[L];
          } catch {
          }
          if (typeof _ === o)
            try {
              var z = window.document.cookie, J = encodeURIComponent(L), Z = z.indexOf(J + "=");
              Z !== -1 && (_ = /^([^;]+)/.exec(
                z.slice(Z + J.length + 1)
              )[1]);
            } catch {
            }
          return h.levels[_] === void 0 && (_ = void 0), _;
        }
      }
      function C() {
        if (!(typeof window === o || !L)) {
          try {
            window.localStorage.removeItem(L);
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(L) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
          } catch {
          }
        }
      }
      function $(_) {
        var z = _;
        if (typeof z == "string" && h.levels[z.toUpperCase()] !== void 0 && (z = h.levels[z.toUpperCase()]), typeof z == "number" && z >= 0 && z <= h.levels.SILENT)
          return z;
        throw new TypeError("log.setLevel() called with invalid level: " + _);
      }
      h.name = b, h.levels = {
        TRACE: 0,
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        SILENT: 5
      }, h.methodFactory = x || u, h.getLevel = function() {
        return k ?? E ?? y;
      }, h.setLevel = function(_, z) {
        return k = $(_), z !== !1 && D(k), m.call(h);
      }, h.setDefaultLevel = function(_) {
        E = $(_), X() || h.setLevel(_, !1);
      }, h.resetLevel = function() {
        k = null, C(), m.call(h);
      }, h.enableAll = function(_) {
        h.setLevel(h.levels.TRACE, _);
      }, h.disableAll = function(_) {
        h.setLevel(h.levels.SILENT, _);
      }, h.rebuild = function() {
        if (r !== h && (y = $(r.getLevel())), m.call(h), r === h)
          for (var _ in i)
            i[_].rebuild();
      }, y = $(
        r ? r.getLevel() : "WARN"
      );
      var T = X();
      T != null && (k = $(T)), m.call(h);
    }
    r = new f(), r.getLogger = function(x) {
      if (typeof x != "symbol" && typeof x != "string" || x === "")
        throw new TypeError("You must supply a name when creating a logger.");
      var h = i[x];
      return h || (h = i[x] = new f(
        x,
        r.methodFactory
      )), h;
    };
    var g = typeof window !== o ? window.log : void 0;
    return r.noConflict = function() {
      return typeof window !== o && window.log === r && (window.log = g), r;
    }, r.getLoggers = function() {
      return i;
    }, r.default = r, r;
  });
})(js);
var _a = js.exports;
const ya = (e, t) => ({
  event: "ga4Event",
  event_name: "navigation",
  navigation: {
    element_position: t ? "Footer legal" : "Footer corporate",
    content_name: e
  }
}), wa = _a.getLogger("TrackingService");
class No {
  constructor(t = window.dataLayer) {
    this.dataLayer = t;
  }
  trackFooterLinkClickEvent(t, o) {
    const s = ya(t, o);
    this.sendEvent(s);
  }
  sendEvent(t) {
    if (!this.dataLayer)
      throw new Error("Don't have a data layer! Did you forget to initialize Google Tag Manager?");
    wa.debug("Tracking: Sending", t), this.dataLayer.push(t);
  }
}
const Fs = Vs(null), Bs = ({ children: e }) => {
  const [t, o] = Se(new No()), s = _e((i) => {
    o(new No(i));
  }, []), n = be(() => ({ trackingService: t, init: s }), [t, s]);
  return /* @__PURE__ */ p(Fs.Provider, { value: n, children: e });
}, Re = () => {
  const e = on(Fs);
  if (!e)
    throw new Error("no footer state context context found");
  return e;
};
function ka(e) {
  return e === "dark" ? "dark-themed" : "light-themed";
}
const $a = () => {
  if (window.OneTrust)
    window.OneTrust.ToggleInfoDisplay();
  else
    throw new Error("OneTrust SDK not available");
}, za = ({ label: e = "Cookie Settings" }) => {
  const { trackingService: t } = Re();
  return /* @__PURE__ */ p(ne, { class: "cookies__link", kind: "normal", size: "small", spacing: "none", tag: "p", weight: "medium", children: /* @__PURE__ */ p(Ye, { href: "", kind: "bare", onClick: () => {
    $a(), t.trackFooterLinkClickEvent(e, !0);
  }, children: e }) });
}, Ea = ({ link: e, isLegalLink: t }) => {
  const { trackingService: o } = Re(), s = Ne(e.label), n = () => {
    o.trackFooterLinkClickEvent(e.label, t);
  };
  return /* @__PURE__ */ p(ne, { class: "link", kind: "normal", size: "small", spacing: "none", tag: "p", weight: "medium", children: /* @__PURE__ */ p(Ye, { href: e.href, target: "_blank", kind: "bare", onClick: n, children: s }) });
}, Ca = ({
  links: e,
  slot: t,
  includeHeader: o,
  headerText: s
}) => {
  const n = t === "legal", i = e.map(
    (r, a) => r.opensCookieSettings ? /* @__PURE__ */ p(za, { label: r.label }, a) : /* @__PURE__ */ p(Ea, { link: r, isLegalLink: n }, a)
  );
  return /* @__PURE__ */ p("div", { class: `column ${t}`, children: [
    o && /* @__PURE__ */ p(H, { children: s ? /* @__PURE__ */ p("div", { class: "column__header", children: /* @__PURE__ */ p(ne, { kind: "subtle", size: "x-small", children: s }) }) : /* @__PURE__ */ p("div", { class: "column__empty-header" }) }),
    i
  ] });
}, Sa = ({ logoUrl: e }) => e ? /* @__PURE__ */ p(Pr, { class: "logo", fit: "contain", image: e }) : null, Aa = ({ copyright: e, logoUrl: t }) => {
  const s = Ne(e ?? "Red Bull"), n = (/* @__PURE__ */ new Date()).getFullYear();
  return /* @__PURE__ */ p("div", { class: "copyright", children: [
    /* @__PURE__ */ p(
      ne,
      {
        class: "copyright__label",
        kind: "subtle",
        size: "small",
        spacing: "none",
        tag: "p",
        weight: "regular",
        children: `© ${n} ${s}`
      }
    ),
    /* @__PURE__ */ p(Sa, { logoUrl: t })
  ] });
}, Ta = "data:image/png;base64,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", Ra = "data:image/png;base64,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", La = () => {
  const { trackingService: e } = Re(), t = (o) => {
    e.trackFooterLinkClickEvent(o, !1);
  };
  return /* @__PURE__ */ p("div", { class: "app-store-links", children: [
    /* @__PURE__ */ p(
      Ye,
      {
        href: "https://play.google.com/store/apps/details?id=laola1.wrc&hl=en_US",
        target: "_blank",
        kind: "bare",
        onClick: () => t("Google Play Store"),
        children: /* @__PURE__ */ p("img", { class: "app-store-links__logo", src: Ra, alt: "Google Play Store" })
      }
    ),
    /* @__PURE__ */ p(
      Ye,
      {
        href: "https://apps.apple.com/us/app/rally-tv/id799442789",
        target: "_blank",
        kind: "bare",
        onClick: () => t("Apple App Store"),
        children: /* @__PURE__ */ p("img", { className: "app-store-links__logo", src: Ta, alt: "Apple App Store" })
      }
    )
  ] });
}, Ia = ({ projectId: e }) => {
  const { trackingService: t } = Re(), o = (a) => {
    t.trackFooterLinkClickEvent(a, !1);
  };
  let s;
  ((a) => {
    a.Facebook = "https://www.facebook.com/", a.Instagram = "https://www.instagram.com/", a.TikTok = "https://www.tiktok.com/", a.X = "https://x.com/", a.YouTube = "https://www.youtube.com/";
  })(s || (s = {}));
  const n = (a, l) => {
    const c = s[a];
    switch (a) {
      case "Facebook":
        return l ? `${c}FIAERC/` : `${c}WorldRally/`;
      case "Instagram":
        return l ? `${c}fiaerc/` : `${c}officialwrc/`;
      case "TikTok":
        return l ? `${c}@fiaerc` : `${c}@wrc`;
      case "X":
        return l ? `${c}FIAERC` : `${c}OfficialWRC`;
      case "YouTube":
        return l ? `${c}@FIAERC` : `${c}@wrc`;
      default:
        return "";
    }
  }, r = e === "c2630611-8fe3-49f6-a432-f180dcd3365b";
  return /* @__PURE__ */ p("div", { class: "social-links", children: [
    /* @__PURE__ */ p(ne, { size: "small", weight: "medium", children: "Follow us on" }),
    /* @__PURE__ */ p(
      ve,
      {
        href: n("Facebook", r),
        Icon: Tr,
        onClick: () => o("Facebook")
      }
    ),
    /* @__PURE__ */ p(
      ve,
      {
        href: n("Instagram", r),
        Icon: Rr,
        onClick: () => o("Instagram")
      }
    ),
    /* @__PURE__ */ p(
      ve,
      {
        href: n("TikTok", r),
        Icon: Lr,
        onClick: () => o("TikTok")
      }
    ),
    /* @__PURE__ */ p(ve, { href: n("X", r), Icon: Ir, onClick: () => o("X") }),
    /* @__PURE__ */ p(
      ve,
      {
        href: n("YouTube", r),
        Icon: Or,
        onClick: () => o("YouTube")
      }
    )
  ] });
}, ve = ({ href: e, Icon: t, onClick: o }) => /* @__PURE__ */ p(H, { children: /* @__PURE__ */ p(Ct, { href: e, size: "small", target: "_blank", kind: "bare", shape: "circle", onClick: o, children: /* @__PURE__ */ p(t, { style: "scale: 1.8", slot: "icon" }) }) }), Oa = "61ea3cd5-80a5-40ee-a325-3e71319a3ba8", Pa = "c2630611-8fe3-49f6-a432-f180dcd3365b", Da = [Oa, Pa], Ha = ({ projectId: e }) => !e || !Da.includes(e) ? null : /* @__PURE__ */ p("div", { class: "top-links", children: [
  /* @__PURE__ */ p(Ia, { projectId: e }),
  /* @__PURE__ */ p(La, {})
] }), Us = ({
  customDataLayer: e,
  uiMode: t = "light",
  projectId: o,
  dataLoader: s,
  _debug: n
}) => {
  const i = ut(null), [r, a] = Se(void 0), l = _e(() => {
    i.current && (window.clearTimeout(i.current), i.current = null);
  }, []), { init: c } = Re(), m = `footer ${ka(t)}`;
  U(() => {
    c(e);
  }, [e, c]), U(() => {
    (async () => {
      l(), i.current = window.setTimeout(async () => {
        if (n) {
          a(n);
          return;
        }
        const g = await s.fetchDataFromFooterApi();
        a(g);
      }, 100);
    })();
  }, [l, n, s]);
  const d = ja(r == null ? void 0 : r.columns), u = d.length;
  return /* @__PURE__ */ p(Dr, { mode: t, children: /* @__PURE__ */ p("footer", { class: m, children: /* @__PURE__ */ p("div", { class: "footer__billboard", children: [
    /* @__PURE__ */ p(Ha, { projectId: o }),
    /* @__PURE__ */ p("div", { class: `footer__content ${u <= 2 ? "standard-layout" : "additional-columns"}`, children: [
      /* @__PURE__ */ p(
        "nav",
        {
          className: "footer__navigation",
          "aria-label": "Footer",
          style: { "--number-of-columns": u },
          children: d.map((f, g) => /* @__PURE__ */ p(
            Ca,
            {
              links: f.links,
              slot: f.slot,
              includeHeader: f.includeHeader,
              headerText: f.headerText
            },
            `col-${g}`
          ))
        }
      ),
      /* @__PURE__ */ p(Aa, { copyright: r == null ? void 0 : r.copyright, logoUrl: r == null ? void 0 : r.logoUrl })
    ] })
  ] }) }) });
};
function ja(e) {
  var s, n;
  if (!e)
    return [];
  const t = [
    e.legalColumn.header,
    (s = e.corporateColumn) == null ? void 0 : s.header,
    ...((n = e.additionalColumns) == null ? void 0 : n.map((i) => i.header)) ?? []
  ].some(Boolean), o = [
    {
      links: e.legalColumn.links,
      slot: "legal",
      includeHeader: t,
      headerText: e.legalColumn.header
    }
  ];
  return e.corporateColumn && o.unshift({
    links: e.corporateColumn.links,
    slot: "corporate",
    includeHeader: t,
    headerText: e.corporateColumn.header
  }), e.additionalColumns && o.push(
    ...e.additionalColumns.map((i) => ({
      links: i.links,
      slot: "addtl",
      includeHeader: t,
      headerText: i.header
    }))
  ), o;
}
const Ns = '.app-store-links{display:flex;gap:16px}.app-store-links__logo{height:40px}@media (min-width: 650px){.cookies__link{grid-column:2}}.copyright{display:flex;gap:24px;flex-direction:column}@media (max-width: 999px){.copyright{align-items:center}}.copyright__label{white-space:nowrap}@media (min-width: 1000px){.copyright__label{text-align:right}}.additional-columns .copyright{align-items:center;text-align:center}.footer{all:initial}.footer__billboard{position:relative;background-color:var(--rb-footer-background-color, white)}.footer__content{padding:32px 0;margin:0 calc((99.99% - 20px)*0 + 16px);flex:0 0 auto;width:calc((99.99% - 20px)*1 - 12px)}@media (min-width: 650px){.footer__content{margin:0 calc((99.99% - 60px)*0 + 40px);flex:0 0 auto;width:calc((99.99% - 60px)*1 - 20px)}}@media (min-width: 1000px){.footer__content{margin:0 calc((99.99% - 104px)*0 + 64px);flex:0 0 auto;width:calc((99.99% - 104px)*1 - 24px)}}@media (min-width: 1600px){.footer__content{margin:0 calc(64px + (100% - 1600px)/2);width:1472px}}@media (min-width: 650px){.footer__content{padding:52px 0}}.footer__navigation{margin-bottom:32px;display:grid;grid-template-columns:1fr;row-gap:16px}@media (min-width: 650px){.footer__navigation{margin-bottom:40px;grid-template-columns:repeat(min(var(--number-of-columns),3),1fr);grid-auto-flow:dense;column-gap:20px;row-gap:60px}}@media (min-width: 1000px){.footer__navigation{margin-bottom:40px;grid-template-columns:repeat(min(var(--number-of-columns),5),1fr);grid-auto-flow:dense;column-gap:20px}}@media (min-width: 1000px){.standard-layout{display:flex;flex-direction:row;justify-content:space-between}}@media (min-width: 1000px){.standard-layout .footer__navigation{width:calc((99.99% + 24px) * .6666666667 - 24px);margin-bottom:0}}@media (min-width: 650px){.additional-columns .footer__navigation{width:100%}}.dark-themed .footer__billboard{background-color:var(--rb-footer-background-color, #00162B)}.column{display:flex;flex-direction:column;gap:16px}.column:not(:first-child):before{content:"";display:block;height:1px;margin:16px 0;background:#000f1e1a}@media (min-width: 650px){.column:not(:first-child):before{display:none}}.column__header{height:20px}.column__empty-header{height:20px;display:none}@media (min-width: 650px){.column__empty-header{display:block}}.dark-themed .column:before{background:#ffffff1a}.logo{max-width:150px;height:auto}.social-links{display:flex;gap:8px;align-items:center}.top-links{display:flex;justify-content:space-between;padding-top:32px;gap:32px;flex-direction:column;margin:0 calc((99.99% - 20px)*0 + 16px);flex:0 0 auto;width:calc((99.99% - 20px)*1 - 12px)}@media (min-width: 650px){.top-links{margin:0 calc((99.99% - 60px)*0 + 40px);flex:0 0 auto;width:calc((99.99% - 60px)*1 - 20px)}}@media (min-width: 1000px){.top-links{margin:0 calc((99.99% - 104px)*0 + 64px);flex:0 0 auto;width:calc((99.99% - 104px)*1 - 24px)}}@media (min-width: 1600px){.top-links{margin:0 calc(64px + (100% - 1600px)/2);width:1472px}}@media (min-width: 1000px){.top-links{padding-top:52px;flex-direction:row}}', Fa = "https://smart-components-api.redbull.com", Ba = "https://rbup-ges-smart-components-backend.eu-central-1.rbup-production.redbullaws.com", Ua = "https://rbup-ges-smart-components-backend.eu-central-1.rbup-staging.redbullaws.com", Na = "https://smart-components-api-staging.redbull.com", Ma = "public-api/footer-configs", qa = "public-api/rbcom-footer-configs";
function Ms(e, t) {
  switch (e) {
    case "PRODUCTION":
      return t ? Ba : Fa;
    case "STAGING":
      return t ? Ua : Na;
    default:
      throw new Error("unknown server environment");
  }
}
function Ga(e, t) {
  return !e || !t ? "" : new URLSearchParams({
    lcmId: e,
    localization: t
  }).toString();
}
const Wa = {
  RedBull: "https://www.redbull.com/v3/resources/images/client/header/redbullcom-logo_double-with-text.svg",
  ContentPool: "https://images.ctfassets.net/9wbsp34au6cz/4ROJy12iUIuSpLTWy7TKL/d963e62d85fa61f58065d1f1fd263dd5/contentpool_light-original-png.png",
  "Neymar Juniors Five": "https://img.redbull.com/images/e_trim:10:transparent/c_limit,w_200,h_117/bo_5px_solid_rgb:00000000/q_auto:best,f_auto/redbullcom/2019/02/04/ccf9b661-7ce7-46bc-b858-4cac291ca3c7/neymar-jrs-5-logo"
};
class Ya {
  constructor(t, o, s) {
    this.projectId = t, this.language = o, this.targetEndpoint = s;
  }
  async fetchDataFromFooterApi() {
    return await Xa(this.projectId, this.language, this.targetEndpoint);
  }
}
async function Xa(e, t, o) {
  if (!e)
    throw new Error("projectId is required!");
  if (!t)
    throw new Error("language is required!");
  const { environment: s, bypassCache: n } = o, i = Ms(s, n);
  let r;
  if (Ka(e)) {
    const { projectId: a, logo: l } = Qa(e), c = Mo(i, a, t);
    r = await Za(c, l, n);
  } else {
    const a = Mo(i, e, t);
    r = await Ja(a, n);
  }
  if (r.ok)
    return await r.json();
  throw new Error(`error loading from server ${r.status}`);
}
async function Ja(e, t) {
  return await fetch(e, t ? { cache: "no-store" } : void 0);
}
async function Za(e, t, o) {
  const n = await fetch(e, o ? { cache: "no-store" } : void 0), i = await n.json();
  return i.logoUrl = Wa[t], new Response(JSON.stringify(i), {
    status: n.status,
    statusText: n.statusText,
    headers: n.headers
  });
}
function Mo(e, t, o) {
  const s = Ga(t, o);
  return `${e}/${Ma}?${s}`;
}
function Qa(e) {
  const [t, o] = e.split("?logo=");
  return {
    projectId: t,
    logo: o
  };
}
function Ka(e) {
  return e.split("?logo=").length !== 1;
}
class Va {
  constructor(t, o) {
    this.locale = t, this.environment = o;
  }
  async fetchDataFromFooterApi() {
    return await ec(this.locale, this.environment);
  }
}
async function ec(e, t) {
  if (!e)
    throw new Error("locale is required!");
  const o = Ms(t, !1), s = await tc(o, e);
  if (s.ok)
    return await s.json();
  throw new Error(`error loading from server ${s.status}`);
}
async function tc(e, t) {
  const o = new URLSearchParams({ locale: t }).toString(), s = `${e}/${qa}?${o}`;
  return await fetch(s);
}
const oc = ({
  customDataLayer: e,
  uiMode: t,
  projectId: o,
  language: s,
  environment: n = "PRODUCTION",
  skipCosmosFontInjection: i,
  bypassCache: r,
  _debug: a
}) => {
  const l = be(() => new Ya(o, s, { environment: n, bypassCache: Me(r) }), [o, s, n, r]);
  return U(() => {
    Me(i) || Ot(It);
  }, [i]), /* @__PURE__ */ p(H, { children: [
    /* @__PURE__ */ p("style", { children: Ns }),
    /* @__PURE__ */ p(Bs, { children: /* @__PURE__ */ p(
      Us,
      {
        customDataLayer: e,
        uiMode: t,
        projectId: o,
        dataLoader: l,
        environment: n,
        _debug: a
      }
    ) })
  ] });
}, sc = ({
  customDataLayer: e,
  environment: t = "PRODUCTION",
  locale: o,
  skipCosmosFontInjection: s,
  uiMode: n,
  _debug: i
}) => {
  const r = be(() => new Va(o, t), [o, t]);
  return U(() => {
    Me(s) || Ot(It);
  }, [s]), /* @__PURE__ */ p(H, { children: [
    /* @__PURE__ */ p("style", { children: Ns }),
    /* @__PURE__ */ p(Bs, { children: /* @__PURE__ */ p(
      Us,
      {
        customDataLayer: e,
        uiMode: n,
        dataLoader: r,
        environment: t,
        _debug: i
      }
    ) })
  ] });
};
function qt() {
  return (qt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];
      for (var s in o) Object.prototype.hasOwnProperty.call(o, s) && (e[s] = o[s]);
    }
    return e;
  }).apply(this, arguments);
}
var nc = ["context", "children"];
function ic(e) {
  this.getChildContext = function() {
    return e.context;
  };
  var t = e.children, o = function(s, n) {
    if (s == null) return {};
    var i, r, a = {}, l = Object.keys(s);
    for (r = 0; r < l.length; r++) n.indexOf(i = l[r]) >= 0 || (a[i] = s[i]);
    return a;
  }(e, nc);
  return rs(t, o);
}
function rc() {
  var e = new CustomEvent("_preact", { detail: {}, bubbles: !0, cancelable: !0 });
  this.dispatchEvent(e), this._vdom = M(ic, qt({}, this._props, { context: e.detail.context }), function t(o, s) {
    if (o.nodeType === 3) return o.data;
    if (o.nodeType !== 1) return null;
    var n = [], i = {}, r = 0, a = o.attributes, l = o.childNodes;
    for (r = a.length; r--; ) a[r].name !== "slot" && (i[a[r].name] = a[r].value, i[qs(a[r].name)] = a[r].value);
    for (r = l.length; r--; ) {
      var c = t(l[r], null), m = l[r].slot;
      m ? i[m] = M(qo, { name: m }, c) : n[r] = c;
    }
    var d = s ? M(qo, null, n) : n;
    return M(s || o.nodeName.toLowerCase(), i, d);
  }(this, this._vdomComponent)), (this.hasAttribute("hydrate") ? is : Qe)(this._vdom, this._root);
}
function qs(e) {
  return e.replace(/-(\w)/g, function(t, o) {
    return o ? o.toUpperCase() : "";
  });
}
function ac(e, t, o) {
  if (this._vdom) {
    var s = {};
    s[e] = o = o ?? void 0, s[qs(e)] = o, this._vdom = rs(this._vdom, s), Qe(this._vdom, this._root);
  }
}
function cc() {
  Qe(this._vdom = null, this._root);
}
function qo(e, t) {
  var o = this;
  return M("slot", qt({}, e, { ref: function(s) {
    s ? (o.ref = s, o._listener || (o._listener = function(n) {
      n.stopPropagation(), n.detail.context = t;
    }, s.addEventListener("_preact", o._listener))) : o.ref.removeEventListener("_preact", o._listener);
  } }));
}
function Gt(e, t, o, s) {
  function n() {
    var i = Reflect.construct(HTMLElement, [], n);
    return i._vdomComponent = e, i._root = s && s.shadow ? i.attachShadow({ mode: s.mode || "open" }) : i, i;
  }
  return (n.prototype = Object.create(HTMLElement.prototype)).constructor = n, n.prototype.connectedCallback = rc, n.prototype.attributeChangedCallback = ac, n.prototype.disconnectedCallback = cc, o = o || e.observedAttributes || Object.keys(e.propTypes || {}), n.observedAttributes = o, o.forEach(function(i) {
    Object.defineProperty(n.prototype, i, { get: function() {
      return this._vdom.props[i];
    }, set: function(r) {
      this._vdom ? this.attributeChangedCallback(i, null, r) : (this._props || (this._props = {}), this._props[i] = r, this.connectedCallback());
      var a = typeof r;
      r != null && a !== "string" && a !== "boolean" && a !== "number" || this.setAttribute(i, r);
    } });
  }), customElements.define(t || e.tagName || e.displayName || e.name, n);
}
const Cc = () => {
  customElements.get(Fe) || Gt(xa, Fe, Ys, { shadow: !0 });
}, Je = "rb-footer", Ze = "rbcom-footer";
async function Sc(e, t) {
  await customElements.whenDefined(Je);
  const o = document.getElementById(e);
  if (!o)
    throw new Error(`html element with id ${e} not found`);
  Object.assign(o, t), pe(o, t);
}
async function Ac(e, t) {
  await customElements.whenDefined(Je), Object.assign(e, t), pe(e, t);
}
async function Tc(e, t) {
  await customElements.whenDefined(Ze);
  const o = document.getElementById(e);
  if (!o)
    throw new Error(`html element with id ${e} not found`);
  Object.assign(o, t), pe(o, t);
}
async function Rc(e, t) {
  await customElements.whenDefined(Ze), Object.assign(e, t), pe(e, t);
}
const lc = [
  "bypass-cache",
  "custom-data-layer",
  "environment",
  "language",
  "project-id",
  "skip-cosmos-font-injection",
  "ui-mode",
  "_debug"
], dc = [
  "custom-data-layer",
  "environment",
  "locale",
  "skip-cosmos-font-injection",
  "ui-mode",
  "_debug"
], Lc = () => {
  customElements.get(Je) || Gt(oc, Je, lc, { shadow: !0 });
}, Ic = () => {
  customElements.get(Ze) || Gt(sc, Ze, dc, { shadow: !0 });
};
export {
  uc as initRbEnergyDrinkRail,
  fc as initRbEnergyDrinkRailWithElement,
  Sc as initRbFooter,
  Ac as initRbFooterWithElement,
  Tc as initRbcomFooter,
  Rc as initRbcomFooterWithElement,
  Cc as registerRbEnergyDrinkRail,
  Lc as registerRbFooter,
  Ic as registerRbcomFooter
};
